webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(308),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15d94212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exception; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RuntimeException__ = __webpack_require__(153);







var exception = function exception(message) {
  return function (target, key, descriptor) {
    var method = descriptor.value;
    descriptor.value = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _len,
            args,
            _key,
            _args = arguments;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                for (_len = _args.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _context.next = 4;
                return method.apply(this, args);

              case 4:
                return _context.abrupt('return', _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                if (!(_context.t0.status != 0)) {
                  _context.next = 13;
                  break;
                }

                throw new __WEBPACK_IMPORTED_MODULE_4__RuntimeException__["a" /* default */](message, _context.t0);

              case 13:
                return _context.abrupt('return', {});

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();
    return descriptor;
  };
};

var toast = function toast(message) {
  return function (target, key, descriptor) {
    var method = descriptor.value;
    descriptor.value = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _len2,
            args,
            _key2,
            _args2 = arguments;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                for (_len2 = _args2.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                _context2.next = 4;
                return method.apply(this, args);

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(message || _context2.t0.message);
                throw _context2.t0;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();
    return descriptor;
  };
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var BaseService = function () {
  function BaseService(data) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BaseService);

    this._data = data;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BaseService, [{
    key: "install",
    value: function install(Vue) {
      this._vm = new Vue({
        data: this.data
      });
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }]);

  return BaseService;
}();



/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategoryApi__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__livesApi__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MovieApi__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewsApi__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OtherApi__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserApi__ = __webpack_require__(151);









var api = {
  category: new __WEBPACK_IMPORTED_MODULE_2__CategoryApi__["a" /* default */](),
  movie: new __WEBPACK_IMPORTED_MODULE_4__MovieApi__["a" /* default */](),
  news: new __WEBPACK_IMPORTED_MODULE_5__NewsApi__["a" /* default */](),
  other: new __WEBPACK_IMPORTED_MODULE_6__OtherApi__["a" /* default */](),
  user: new __WEBPACK_IMPORTED_MODULE_7__UserApi__["a" /* default */](),
  lives: new __WEBPACK_IMPORTED_MODULE_3__livesApi__["a" /* default */]()
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, api, {
  install: function install(Vue) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(api).forEach(function (key) {
      return api[key].install(Vue);
    });
  }
}));

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_indicator_style_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_indicator__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);









var domain = 'https://data-api.sanmanuela.net/api';
var prefix = {
  app: 'fytv',
  device: 'mobile',
  version: '1.1.0'
};

var BaseApi = function () {
  function BaseApi() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, BaseApi);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(BaseApi, [{
    key: 'install',
    value: function install(Vue) {
      this._http = Vue.http;
    }
  }, {
    key: 'postRequest',
    value: function postRequest(response, url) {
      return response;
    }
  }, {
    key: 'sendHttpRequest',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(method, url, _ref2) {
        var body = _ref2.body,
            params = _ref2.params,
            headers = _ref2.headers;
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_indicator___default.a.open({
                  text: '加载中...',
                  spinnerType: 'fading-circle'
                });
                if (url.indexOf('//') == -1) {
                  url = domain + url;
                }
                params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, prefix, params);
                _context.next = 6;
                return this._http({
                  method: method,
                  url: url,
                  body: body,
                  params: params,
                  headers: headers
                });

              case 6:
                response = _context.sent;
                return _context.abrupt('return', this.postRequest(response.body, url));

              case 8:
                _context.prev = 8;

                __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_indicator___default.a.close();
                return _context.finish(8);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0,, 8, 11]]);
      }));

      function sendHttpRequest(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return sendHttpRequest;
    }()
  }, {
    key: 'httpJsonp',
    value: function httpJsonp(url, params) {
      return this.sendHttpRequest('jsonp', url, {
        params: params
      });
    }
  }, {
    key: 'httpGet',
    value: function httpGet(url, params) {
      return this.sendHttpRequest('get', url, {
        params: params
      });
    }
  }, {
    key: 'httpPost',
    value: function httpPost(url, body, params) {
      return this.sendHttpRequest('post', url, {
        body: body,
        params: params
      });
    }
  }, {
    key: 'httpPut',
    value: function httpPut(url, body, params) {
      return this.sendHttpRequest('put', url, {
        body: body,
        params: params
      });
    }
  }, {
    key: 'httpPatch',
    value: function httpPatch(url, body, params) {
      return this.sendHttpRequest('patch', url, {
        body: body,
        params: params
      });
    }
  }, {
    key: 'httpDelete',
    value: function httpDelete(url, params) {
      return this.sendHttpRequest('delete', url, {
        params: params
      });
    }
  }]);

  return BaseApi;
}();



/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CategoryService__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommonService__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LiveService__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MovieService__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NewsService__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OtherService__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserService__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WechatService__ = __webpack_require__(146);












var services = {
  common: new __WEBPACK_IMPORTED_MODULE_4__CommonService__["a" /* default */](),
  category: new __WEBPACK_IMPORTED_MODULE_3__CategoryService__["a" /* default */](),
  movie: new __WEBPACK_IMPORTED_MODULE_6__MovieService__["a" /* default */](),
  news: new __WEBPACK_IMPORTED_MODULE_7__NewsService__["a" /* default */](),
  user: new __WEBPACK_IMPORTED_MODULE_9__UserService__["a" /* default */](),
  other: new __WEBPACK_IMPORTED_MODULE_8__OtherService__["a" /* default */](),
  wechat: new __WEBPACK_IMPORTED_MODULE_10__WechatService__["a" /* default */](),
  lives: new __WEBPACK_IMPORTED_MODULE_5__LiveService__["a" /* default */]()
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, services, {
  install: function install(Vue, options) {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].install(Vue);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(services).forEach(function (key) {
      return services[key].install(Vue);
    });
    Vue.prototype.$service = this;

    services.other.loadSetting();
  }
}));

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9711643a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72cc1eeb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);





var jsBridge = void 0;

function getJsBridage() {
    if (!jsBridge) {
        if (window.tv) {
            var postMessage = function postMessage(event) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                window.tv.postMessage(event, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params));
            };
            jsBridge = {
                navigateBack: function navigateBack() {
                    if (window.appVersion == '3.3.0') {
                        window.tv.navigateBack();
                    } else {
                        postMessage('goBack');
                    }
                },
                webShare: function webShare(title, text, img, path) {
                    img = img.replace('https://', 'http://');
                    path = path.replace('https://', 'http://');
                    if (window.appVersion == '3.3.0') {
                        window.tv.webShare(title, text, img, path);
                    } else {
                        postMessage('share', {
                            title: title,
                            text: text,
                            img: img,
                            path: path
                        });
                    }
                },
                openView: function openView(url, inner, hideHeader) {
                    if (window.appVersion == '3.3.0') {
                        window.tv.openView(url, inner);
                    } else {
                        postMessage('openView', {
                            url: url,
                            inner: inner,
                            hideHeader: hideHeader
                        });
                    }
                },
                fyPlayer: function fyPlayer(movid, urlid) {
                    postMessage('fyPlayer', {
                        movid: movid,
                        urlid: urlid
                    });
                }
            };
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsBridge) {
            var _postMessage = function _postMessage(event) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                window.webkit.messageHandlers.jsBridge.postMessage(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    event: event,
                    params: params
                }));
            };
            jsBridge = {
                navigateBack: function navigateBack() {
                    _postMessage('goBack');
                },
                webShare: function webShare(title, text, img, path) {
                    _postMessage('share', {
                        title: title,
                        text: text,
                        img: img,
                        path: path
                    });
                },
                openView: function openView(url, inner, hideHeader) {
                    _postMessage('openView', {
                        url: url,
                        inner: inner,
                        hideHeader: hideHeader
                    });
                },
                fyPlayer: function fyPlayer(movid, urlid) {
                    _postMessage('fyPlayer', {
                        movid: movid,
                        urlid: urlid
                    });
                }
            };
        } else if (window.flutter_inappwebview) {
            var _postMessage2 = function _postMessage2(event) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                window.flutter_inappwebview.callHandler('postMessage', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    event: event,
                    params: params
                }));
            };
            jsBridge = {
                navigateBack: function navigateBack() {
                    _postMessage2('goBack');
                },
                webShare: function webShare(title, text, img, path) {
                    _postMessage2('share', {
                        title: title,
                        text: text,
                        img: img,
                        path: path
                    });
                },
                openView: function openView(url, inner, hideHeader) {
                    _postMessage2('openView', {
                        url: url,
                        inner: inner,
                        hideHeader: hideHeader
                    });
                },
                fyPlayer: function fyPlayer(movid, urlid) {
                    _postMessage2('fyPlayer', {
                        movid: parseInt(movid),
                        urlid: parseInt(urlid)
                    });
                }
            };
        } else if (window.tvFlutter) {
            var _postMessage3 = function _postMessage3(event) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                window.tvFlutter.postMessage(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    event: event,
                    params: params
                }));
            };
            jsBridge = {
                navigateBack: function navigateBack() {
                    _postMessage3('goBack');
                },
                webShare: function webShare(title, text, img, path) {
                    _postMessage3('share', {
                        title: title,
                        text: text,
                        img: img,
                        path: path
                    });
                },
                openView: function openView(url, inner, hideHeader) {
                    _postMessage3('openView', {
                        url: url,
                        inner: inner,
                        hideHeader: hideHeader
                    });
                },
                fyPlayer: function fyPlayer(movid, urlid) {
                    _postMessage3('fyPlayer', {
                        movid: parseInt(movid),
                        urlid: parseInt(urlid)
                    });
                }
            };
        } else {
            jsBridge = {
                navigateBack: function navigateBack() {
                    __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('not found jsbridge');
                },
                webShare: function webShare(title, text, img, path) {
                    __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('not found jsbridge');
                },
                openView: function openView(url, inner, hideHeader) {
                    __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('not found jsbridge');
                    window.location.href = url;
                },
                fyPlayer: function fyPlayer(movid, urlid) {
                    __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('not found jsbridge');
                }
            };
        }
    }
    return jsBridge;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    error: function error(message) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(message);
    },
    toast: function toast(message) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(message);
    },
    callShare: function callShare(title, text, img, path) {
        if (title.length > 20) {
            title = title.substr(0, 20) + '...';
        }
        getJsBridage().webShare(title, text, img, path);
    },
    callGoBack: function callGoBack() {
        getJsBridage().navigateBack();
    },
    openView: function openView(url, inner) {
        var hideHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        getJsBridage().openView(url, inner, hideHeader);
    },
    fyPlayer: function fyPlayer(movid, urlid) {
        getJsBridage().fyPlayer(movid, urlid);
    }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(307),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-125c91fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export icon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return n2; });
/* unused harmony export date */
/* unused harmony export datetime */
/* unused harmony export datetime2 */
/* unused harmony export seconds */
/* unused harmony export unit */
var ICONS = {
  '主日讲道': 'icon-podium',
  '福音证道': 'icon-bible',
  '福音慕道': 'icon-prayer',
  '婚姻家庭': 'icon-house',
  '赞美敬拜': 'icon-microphone',
  '福音视频': 'icon-television',
  '福音动漫': 'icon-mickey',
  '圣乐教室': 'icon-headset',
  '初信造就': 'icon-class',
  '神学课程': 'icon-podium',
  '福音见证': 'icon-parenting'
};

var icon = function icon(value) {
  return ICONS[value];
};

var n2 = function n2(value) {
  if (value < 10) {
    return '0' + value;
  } else {
    return value;
  }
};

var date = function date(value) {
  var dt = new Date(value * 1000);
  return dt.getFullYear() + '-' + n2(dt.getMonth() + 1) + '-' + n2(dt.getDate());
};

var datetime = function datetime(value) {
  var dt = new Date(value * 1000);
  return dt.getFullYear() + '-' + n2(dt.getMonth() + 1) + '-' + n2(dt.getDate()) + ' ' + n2(dt.getHours()) + ':' + n2(dt.getMinutes());
};

var datetime2 = function datetime2(value) {
  var dt = new Date(value * 1000);
  return n2(dt.getMonth() + 1) + '-' + n2(dt.getDate()) + ' ' + n2(dt.getHours()) + ':' + n2(dt.getMinutes());
};

var seconds = function seconds(_seconds) {
  var minutes = parseInt(_seconds / 60);
  var hours = parseInt(minutes / 60);
  _seconds = _seconds % 60;
  minutes = minutes % 60;
  if (hours > 0) {
    return n2(hours) + ':' + n2(minutes) + ':' + n2(_seconds);
  } else {
    return n2(minutes) + ':' + n2(_seconds);
  }
};

function unit(value) {
  if (value > 10000) {
    var suffix = '';
    value = value / 10000;
    suffix = '万';
    if (value > 10000) {
      value = value / 10000;
      suffix = '亿';
    }
    return value.toFixed(1) + suffix;
  } else {
    return value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.filter('icon', icon);
    Vue.filter('date', date);
    Vue.filter('datetime', datetime);
    Vue.filter('datetime2', datetime2);
    Vue.filter('seconds', seconds);
    Vue.filter('unit', unit);
  }
});

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(29);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__view__["a" /* default */]
});

var isFirst = true;
var isPush = false;
var originPush = router.push;
var originReplace = router.replace;
router.push = function () {
  isPush = true;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  originPush.apply(router, args);
};

router.replace = function () {
  isPush = true;

  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  originReplace.apply(router, args);
};
router.beforeEach(function (to, from, next) {
  if (!from.meta) {
    from.meta = {};
  }
  from.meta.scrollTop = document.body.scrollTop;
  next();
});

router.afterEach(function (route) {
  __WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].common.title = '';
  __WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].common.tool = false;
  __WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].wechat.callShare();
  if (!route.meta) {
    route.meta = {};
  }
  if (isFirst) {
    isFirst = false;
    isPush = true;
  }
  route.meta.isPush = isPush;
  isPush = false;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__view_components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_components_MovieCover_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_components_MovieCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_components_MovieCover_vue__);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default.a;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_4__view_components_AppView_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_4__view_components_AppView_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__view_components_MovieCover_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_5__view_components_MovieCover_vue___default.a);

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(328),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58a51c0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppFoot_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppFoot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppFoot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppHead_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppHead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppShare_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppShare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppShare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppTool_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppTool_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppTool_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__welcome_index_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__welcome_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__welcome_index_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        AppHead: __WEBPACK_IMPORTED_MODULE_1__components_AppHead_vue___default.a,
        AppFoot: __WEBPACK_IMPORTED_MODULE_0__components_AppFoot_vue___default.a,
        AppTool: __WEBPACK_IMPORTED_MODULE_3__components_AppTool_vue___default.a,
        AppShare: __WEBPACK_IMPORTED_MODULE_2__components_AppShare_vue___default.a,
        Welcome: __WEBPACK_IMPORTED_MODULE_4__welcome_index_vue___default.a
    },
    data: function data() {
        return {
            homeRoute: '',
            welcomeVisible: !!window.ad
        };
    },

    computed: {
        isLives: function isLives() {
            return this.$route.path.indexOf('/lives') >= 0;
        },
        headVisible: function headVisible() {
            return !this.$service.common.noHead;
        },
        backVisible: function backVisible() {
            return !this.footVisible && (this.homeRoute != this.$route.name || !this.isHome);
        },
        footVisible: function footVisible() {
            return !window.inApp && window.isM;
        },
        viewClass: function viewClass() {
            return ['app' + (this.headVisible ? 1 : 0) + (this.footVisible ? 1 : 0), this.isLives ? 'live-page' : ''];
        },
        isToolDisabled: function isToolDisabled() {
            return !window.isM || window.inApp || this.$route.name === 'welcome' || this.$route.name === 'pay' || this.$route.name === 'phone' || this.$route.name == 'subscribe';
        },
        isDownVisible: function isDownVisible() {
            return window.inApp || this.$route.name === 'welcome' || this.$route.name === 'pay' || this.$route.name === 'phone';
        },
        isHome: function isHome() {
            return window.query.home == 1;
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            var event = document.createEvent('Event');
            event.initEvent('app-ready', true, true);
            document.dispatchEvent(event);
        }, 500);
        this.homeRoute = this.$route.name;
        this.$service.user.initialize(this);
        window.onAd = function () {
            _this.welcomeVisible = window.ad;
        };
    }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__);


//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, HtmlContent: __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default.a },
  data: function data() {
    return {
      value: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.other.loadAbout();

            case 2:
              _this.value = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default.a },
  data: function data() {
    return {
      selected: 0
    };
  },

  computed: {
    bible: function bible() {
      return this.$service.category.bible;
    },
    contents: function contents() {
      return this.bible[this.selected] && this.bible[this.selected].child;
    }
  },
  mounted: function mounted() {
    this.$service.category.loadBible();
  },

  methods: {
    onSelected: function onSelected(i) {
      this.selected = i;
    },
    onGo: function onGo(item) {
      this.$router.push({
        name: 'bookshelf',
        query: {
          bid: item.bible_id,
          name: item.name
        }
      });
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MovieCover_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MovieCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MovieCover_vue__);


//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, List: __WEBPACK_IMPORTED_MODULE_3__components_List_vue___default.a, MovieCover: __WEBPACK_IMPORTED_MODULE_4__components_MovieCover_vue___default.a },
  computed: {
    catid: function catid() {
      return this.$route.params.catid;
    },
    catname: function catname() {
      return this.$route.query.name;
    },
    recommendation: function recommendation() {
      return this.$route.query.recmd;
    },
    bid: function bid() {
      return this.$route.query.bid;
    },
    bookshelf: function bookshelf() {
      return this.$service.movie.bookshelf;
    }
  },
  methods: {
    clear: function clear() {
      this.$service.movie.clearBookShelf();
    },
    loadNextPage: function loadNextPage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var catid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.catid) {
                  _context.next = 13;
                  break;
                }

                catid = parseInt(_this.catid);

                if (!isNaN(catid)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return _this.$service.movie.loadBookShelfByRecommendation();

              case 5:
                return _context.abrupt('return', _context.sent);

              case 8:
                _context.next = 10;
                return _this.$service.movie.loadBookShelfByCategory(_this.catid);

              case 10:
                return _context.abrupt('return', _context.sent);

              case 11:
                _context.next = 22;
                break;

              case 13:
                if (!_this.bid) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _this.$service.movie.loadBookShelfByBible(_this.bid);

              case 16:
                return _context.abrupt('return', _context.sent);

              case 19:
                _context.next = 21;
                return _this.$service.movie.loadBookShelfByRecommendation(parseInt(_this.recommendation));

              case 21:
                return _context.abrupt('return', _context.sent);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onOpen: function onOpen() {
      var _this2 = this;

      this.$refs.list.reload();
      this.$service.common.title = this.catname;
      var link = 'https://' + window.location.host + '/#/bookshelf';
      if (this.catid) {
        link = link + '/' + this.catid + '?name=' + this.catname;
      } else if (this.bid) {
        link = link + '?bid=' + this.bid + '&name=' + this.catname;
      } else {
        link = link + '?recmd=' + this.recommendation + '&name=' + this.catname;
      }
      setTimeout(function () {
        _this2.$service.wechat.callShare({
          title: _this2.catname,
          link: link
        });
      }, 2000);
    },
    onRestore: function onRestore() {
      if (this.bookshelf.length > 0) {
        this.$service.common.title = this.catname;
      } else {
        this.onOpen();
      }
    },
    onClose: function onClose() {
      this.clear();
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue__);


//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, MovieCover: __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue___default.a },
  data: function data() {
    return {
      type: 0,
      newList: [],
      updateList: []
    };
  },

  computed: {
    list: function list() {
      return this.type === 0 ? this.updateList : this.newList;
    },
    more: function more() {
      return this.type === 0 ? 'update' : 'add';
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, new_list, update_list;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.movie.loadLatest();

            case 2:
              _ref = _context.sent;
              new_list = _ref.new_list;
              update_list = _ref.update_list;

              _this.newList = new_list;
              _this.updateList = update_list;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default.a },
  computed: {
    all: function all() {
      return this.$service.category.all;
    }
  },
  mounted: function mounted() {
    this.$service.category.loadAllCategories();
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default.a },
  computed: {
    roots: function roots() {
      return this.$service.category.roots;
    }
  },
  mounted: function mounted() {
    window.location.href = 'http://www.fytvapp.com/';
    this.$service.category.loadRootCategories();
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default.a },
  computed: {
    priest: function priest() {
      return this.$service.category.priest;
    }
  },
  mounted: function mounted() {
    this.$service.category.loadPriests();
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      visible: false,
      message: '',
      ok: '',
      cancel: '',
      showTime: 0,
      promise: null
    };
  },

  methods: {
    show: function show(message) {
      var _this = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$ok = _ref.ok,
          ok = _ref$ok === undefined ? '确定' : _ref$ok,
          _ref$cancel = _ref.cancel,
          cancel = _ref$cancel === undefined ? '取消' : _ref$cancel;

      this.message = message;
      this.ok = ok;
      this.cancel = cancel;
      this.visible = true;
      this.showTime = new Date().getTime();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.promise = { resolve: resolve, reject: reject };
      });
    },
    onCancel: function onCancel() {
      if (new Date().getTime() - this.showTime < 1000) {
        return;
      }
      this.visible = false;
      this.promise.resolve(false);
    },
    onOK: function onOK() {
      if (new Date().getTime() - this.showTime < 1000) {
        return;
      }
      this.visible = false;
      this.promise.resolve(true);
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentRoute: function currentRoute() {
      return this.$route.name;
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    backVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    title: function title() {
      return this.$service.common.title || this.$route.meta.title || '福音TV';
    },
    isLives: function isLives() {
      return this.$route.path.indexOf('/lives') >= 0;
    }
  },
  methods: {
    goBack: function goBack() {
      var _this = this;

      if (window.inApp) {
        var route = this.$route.name;
        this.$router.go(-1);
        setTimeout(function () {
          if (_this.$route.name == route) {
            __WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */].callGoBack();
          }
        }, 20);
      } else {
        this.$router.go(-1);
      }
    },
    showMenu: function showMenu() {
      this.$service.common.menu = true;
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    visible: function visible() {
      return this.$service.common.share;
    }
  },
  methods: {
    onClose: function onClose() {
      this.$service.common.share = false;
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    on: function on() {
      return this.$service.common.tool;
    }
  },
  methods: {
    onSwitch: function onSwitch() {
      this.$service.common.tool = !this.$service.common.tool;
    },
    onHome: function onHome() {
      if (this.on) {
        if (this.$route.name !== 'home') {
          this.$router.push({ name: 'home' });
        } else {
          this.$service.common.tool = false;
        }
      }
    },
    onSearch: function onSearch() {
      if (this.on) {
        this.$router.push({ name: 'search' });
      }
    },
    onShare: function onShare() {
      if (this.on) {
        this.$service.common.tool = false;
        this.$service.common.share = true;
      }
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppView',
  props: {
    custom: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hasActivated: false,
      hasDeactivated: false
    };
  },

  computed: {
    footVisible: function footVisible() {
      return this.$service.common.footVisible;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.meta.isPush) {
      this.$emit('open');
      this.$nextTick(function () {
        document.body.scrollTop = 0;
      });
    } else {
      this.$emit('restore');
      this.$nextTick(function () {
        document.body.scrollTop = _this.$route.meta.scrollTop;
      });
    }
    this.hasActivated = true;
  },
  activated: function activated() {
    var _this2 = this;

    if (!this.hasActivated) {
      if (this.$route.meta.isPush) {
        this.$emit('open');
        this.$nextTick(function () {
          document.body.scrollTop = 0;
        });
      } else {
        this.$emit('restore');
        this.$nextTick(function () {
          document.body.scrollTop = _this2.$route.meta.scrollTop;
        });
      }
      this.hasActivated = true;
      this.hasDeactivated = false;
    }
  },
  deactivated: function deactivated() {
    if (this.$route.meta.isPush) {
      this.$emit('hide');
    } else {
      this.$emit('close');
    }
    this.hasDeactivated = true;
    this.hasActivated = false;
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.hasDeactivated) {
      if (this.$route.meta.isPush) {
        this.$emit('hide');
      } else {
        this.$emit('close');
      }
      this.hasDeactivated = true;
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_loadmore_style_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_loadmore_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_loadmore_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_loadmore__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_loadmore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_loadmore__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loadmore: __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_loadmore___default.a },
  props: {
    loadNextPage: {
      type: Function,
      required: true
    },
    clear: {
      type: Function,
      required: true
    }
  },
  methods: {
    reload: function reload() {
      this.end = false;
      this.clear();
      this.loadMore(true);
    },
    loadMore: function loadMore() {
      var _this = this;

      var isRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.loadNextPage();

              case 3:
                _context.prev = 3;

                if (isRefresh) {
                  _this.$refs.loadMore.onTopLoaded();
                } else {
                  _this.$refs.loadMore.onBottomLoaded();
                }
                return _context.finish(3);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 3, 6]]);
      }))();
    }
  }
}); //
//
//
//
//

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MovieCover',
  props: {
    value: {},
    event: {
      type: String,
      default: ''
    },
    more: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      tap: 0
    };
  },

  methods: {
    onTouchStart: function onTouchStart() {
      var _this = this;

      this.tap = setTimeout(function () {
        _this.$emit('longTap', _this.value);
      }, 1000);
    },
    onTouchEnd: function onTouchEnd() {
      clearTimeout(this.tap);
    },
    onClick: function onClick() {
      if (this.event) {
        this.$emit(this.event, this.value);
      } else {
        this.$router.push({
          name: 'movie',
          params: {
            movid: this.value.movid
          }
        });
      }
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppConfirm: __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default.a },
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.user.getFavourites();

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              data.forEach(function (d) {
                d.pic = d.thumb;
                d.movid = d.tid;
              });
              _this.list = data;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onLongTap: function onLongTap(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$refs.confirm.show('您确定要删除该收藏视频吗?');

              case 2:
                if (!_context2.sent) {
                  _context2.next = 8;
                  break;
                }

                index = _this2.list.indexOf(item);

                if (!(index >= 0)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return _this2.$service.user.removeFavourite(item.id);

              case 7:
                _this2.list.splice(index, 1);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'mt-swipe': __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe___default.a,
    'mt-swipe-item': __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item___default.a
  },
  computed: {
    list: function list() {
      return this.$service.other.banner;
    }
  },
  methods: {
    onClick: function onClick(item) {
      if (item.type === 'movie') {
        this.$router.push({
          name: 'movie',
          params: {
            movid: item.val
          }
        });
      } else if (item.type === 'category') {
        this.$router.push({
          name: 'bookshelf',
          params: {
            catid: item.val
          }
        });
      } else if (item.type === 'link') {
        window.location = item.val;
      }
    }
  }
}); //
//
//
//
//
//
//
//
//

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    menu: function menu() {
      return this.$service.other.setting.index_menu;
    },
    ad: function ad() {
      return this.$service.other.setting.index_ad;
    }
  },
  methods: {
    onClickAd: function onClickAd() {
      this.onClick(this.ad);
    },
    onClick: function onClick(item) {
      this.$service.other.goItem(item, this.$router);
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MovieCover_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MovieCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MovieCover_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { MovieCover: __WEBPACK_IMPORTED_MODULE_0__components_MovieCover_vue___default.a },
  props: {
    value: {}
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Banner_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Banner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Banner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Quick_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Quick_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Quick_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recommendation_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Recommendation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Recommendation_vue__);


//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { AppView: __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue___default.a, Banner: __WEBPACK_IMPORTED_MODULE_4__Banner_vue___default.a, Quick: __WEBPACK_IMPORTED_MODULE_5__Quick_vue___default.a, Recommendation: __WEBPACK_IMPORTED_MODULE_6__Recommendation_vue___default.a, AppConfirm: __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default.a },
    computed: {
        recommendations: function recommendations() {
            return this.$service.other.recommendations;
        },
        unreadVisible: function unreadVisible() {
            return this.$service.news.unread;
        }
    },

    methods: {
        onOpen: function onOpen() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.info('startup .....');
                                window.location.href = 'http://www.fytvapp.com/';
                                _this.$service.other.loadBanners();
                                _this.$service.other.loadHomeRecommendations();
                                _this.$service.news.loadNews();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onRestore: function onRestore() {
            if (this.$service.other.banner.length === 0) {
                this.onOpen();
            }
        }
    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_aliplayer__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_filters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AppView_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { AppView: __WEBPACK_IMPORTED_MODULE_7__components_AppView_vue___default.a },
    filters: {
        bg: function bg(url) {
            return {
                backgroundImage: 'url(' + url + ')'
            };
        }
    },
    computed: {
        shareVisible: function shareVisible() {
            return window.inApp && this.item.share_status > 0;
        },
        id: function id() {
            return this.$route.params.id;
        },
        height169: function height169() {
            return window.innerWidth * 9 / 16;
        }
    },
    data: function data() {
        return {
            item: {},
            onlineCount: 0,
            leftTime: -1,
            timeIndex: -1,
            player: null,
            chatWS: null,
            movid: '',
            urlid: '',
            videoUrl: '',
            videoPoster: '',
            adVisible: true
        };
    },

    methods: {
        onAdClosed: function onAdClosed() {
            this.adVisible = false;
        },
        onPlayerVideo: function onPlayerVideo(movid, urlid) {
            if (window.inApp) {
                __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].fyPlayer(movid, urlid);
            } else {
                this.$router.push('/movie/' + movid + '?urlid=' + urlid);
            }
        },
        onShowShare: function onShowShare() {
            var url = 'https://mfuyin.tv/index.html?#/lives/' + this.item.id;
            if (this.item.share_url) {
                url = this.item.share_url;
            }
            __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].callShare(this.item.title, '一起看-福音影视网 iFUYIN.COM', this.item.thumb, url);
        },
        onShowSupport: function onShowSupport() {
            if (window.inApp) {
                __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].openView(this.item.donate_url, this.item.donate_target == 1, true);
            } else {
                window.location.href = this.item.donate_url;
            }
        },
        onOpenUrl: function onOpenUrl(url) {
            if (window.inApp) {
                __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].openView(url, true, true);
            } else {
                window.location.href = url;
            }
        },
        onOpen: function onOpen() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var item, dt, offset, map, goods;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$service.lives.getDetail(_this.id);

                            case 2:
                                item = _context.sent;

                                _this.$service.lives.postHit('live', _this.id);
                                if (item.item_json && item.item_json.length > 0) {
                                    dt = new Date();
                                    offset = dt.getTimezoneOffset() + 480;

                                    item.item_json.forEach(function (item) {
                                        var ts = item.key.split(':');
                                        var value = parseInt(ts[0]) * 60 + parseInt(ts[1]);
                                        var dayMinute = 24 * 60;
                                        value = value - offset;
                                        if (value < 0) {
                                            value = value + dayMinute;
                                        } else if (value > dayMinute) {
                                            value = value - dayMinute;
                                        }

                                        var hours = Math.floor(value / 60);
                                        var minutes = value % 60;
                                        item.time = hours * 100 + minutes;
                                        item.key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_filters__["b" /* n2 */])(hours) + ':' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_filters__["b" /* n2 */])(minutes);
                                    });
                                }

                                map = {};
                                goods = localStorage.getItem('live-goods');

                                if (goods) {
                                    try {
                                        map = JSON.parse(goods);
                                    } catch (e) {}
                                }
                                item.good = !!map[item.id];
                                _this.onlineCount = item.online;
                                _this.item = item;
                                _this.$service.common.title = _this.item.title;
                                _this.createChatWebsocket();
                                _this.updateLive(item);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onClose: function onClose() {
            clearInterval(this.timer);
            if (this.player) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_aliplayer__["a" /* dispostAliPlayer */])('video', this.player);
            }
            clearInterval(this.chatTimer);
            if (this.chatWS) {
                this.chatWS.retry = false;
                this.chatWS.close();
            }
        },
        onTimer: function onTimer() {
            if (this.leftTime > 0) {
                var offset = Math.floor(this.item.starttime - Date.now() / 1000);
                if (offset < 3600 * 24) {
                    this.leftTime = offset;
                    if (offset <= 0) {
                        this.onOpen();
                        return;
                    }
                } else {
                    this.leftTime = -1;
                }
            }
            if (this.item.item_json && this.item.item_json.length > 0) {
                var dt = new Date();
                var hours = dt.getHours();
                var minutes = dt.getMinutes();
                var time = hours * 100 + minutes;
                var i = this.item.item_json.findIndex(function (item) {
                    return item.time > time;
                });
                if (i < 0) {
                    i = this.item.item_json.length - 1;
                } else {
                    i--;
                }
                if (i >= 0 && this.timeIndex != i) {
                    this.timeIndex = i;
                    window.scroll(0, i * 24);
                }
            }
        },
        onVote: function onVote(item) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var map, goods;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!item.good) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.next = 4;
                                return _this2.$service.lives.postVote(item.id);

                            case 4:
                                item.good = true;
                                item.agree++;
                                map = {};
                                goods = localStorage.getItem('live-goods');

                                if (goods) {
                                    try {
                                        map = JSON.parse(goods);
                                    } catch (e) {}
                                }
                                map[item.id] = 1;
                                localStorage.setItem('live-goods', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(map));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        updateLive: function updateLive(item) {
            var _this3 = this;

            this.leftTime = -1;
            if (item.push_status == 0) {
                var offset = Math.floor(item.starttime - Date.now() / 1000);
                if (offset < 3600 * 24) {
                    this.leftTime = offset;
                }
            } else if (item.push_status == 1) {
                setTimeout(function () {
                    _this3.createPlayer(item.play_url, true);
                }, 20);
            } else if (item.push_status == 3) {
                if (item.player_type == 0) {
                    setTimeout(function () {
                        _this3.createPlayer(item.playback_url, false);
                    }, 20);
                } else {
                    item.push_status = 4;
                    var ids = item.playback_urlid.split('-');
                    this.movid = ids[0];
                    this.urlid = ids[1];
                }
            }
            this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item, item);
            clearInterval(this.timer);
            this.timer = setInterval(this.onTimer, 1000);
        },
        createPlayer: function createPlayer(source, isLive) {
            if (window.app == 'ios') {
                this.videoUrl = source;
                this.videoPoster = this.item.thumb;
            } else {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_aliplayer__["a" /* dispostAliPlayer */])('video', this.player);
                this.player = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_aliplayer__["b" /* createAliPlayer */])('video', source, function () {}, { isLive: isLive, auto: true, poster: '', rate: !isLive });
            }
        },
        createChatWebsocket: function createChatWebsocket() {
            var _this4 = this;

            if (this.chatWS) {
                this.chatWS.retry = false;
                this.chatWS.close();
                clearInterval(this.chatTimer);
            }
            var chat = new WebSocket('wss://ws-live.sanmanuela.net/yqk');
            //@ts-ignore
            chat.retry = true;
            this.chatTimer = setInterval(function () {
                chat.send('{"type":"pong"}');
            }, 50000);
            chat.onmessage = function (e) {
                console.info('<<<', e.data);
                try {
                    var msg = JSON.parse(e.data);
                    switch (msg.type) {
                        case 'ping':
                            break;
                        case 'online':
                            _this4.onlineCount = msg.online_count;
                            break;
                        case 'not_publish':
                        case 'publish':
                        case 'publish_done':
                        case 'playback':
                            if (_this4.player) {
                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_aliplayer__["a" /* dispostAliPlayer */])('video', _this4.player);
                                _this4.player = null;
                            }
                            setTimeout(function () {
                                _this4.updateLive(msg.room);
                            }, msg.delay * 1000 + 2000);
                            break;
                        default:
                            console.info('unknow', e.data);
                            break;
                    }
                } catch (err) {
                    console.info('unknow', e.data);
                }
            };
            chat.onopen = function () {
                chat.send(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ type: 'login', room_id: _this4.id }));
            };
            chat.onclose = function () {
                //@ts-ignore
                console.info('-chat close', chat.retry);
                //@ts-ignore
                if (chat.retry) {
                    setTimeout(_this4.createChatWebsocket, 3000);
                }
            };
            chat.onerror = function () {
                //@ts-ignore
                console.info('-chat error', chat.retry);
                chat.close();
                //@ts-ignore
                if (chat.retry) {
                    //@ts-ignore
                    chat.retry = false;
                    setTimeout(_this4.createChatWebsocket, 3000);
                }
            };
            this.chatWS = chat;
        }
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AppView_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { AppView: __WEBPACK_IMPORTED_MODULE_5__components_AppView_vue___default.a },
    filters: {
        bg: function bg(url) {
            return {
                backgroundImage: 'url(' + url + ')'
            };
        }
    },
    data: function data() {
        return {
            list: []
        };
    },

    computed: {
        canShare: function canShare() {
            return window.inApp;
        }
    },
    methods: {
        onShowShare: function onShowShare(item) {
            var url = 'https://mfuyin.tv/index.html?#/lives/' + item.id;
            if (item.share_url) {
                url = item.share_url;
            }
            __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].callShare(item.title, '一起看-福音影视网 iFUYIN.COM', item.thumb, url);
        },
        onShowSupport: function onShowSupport(item) {
            if (window.inApp) {
                __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */].openView(item.donate_url, item.donate_target == 1, true);
            } else {
                window.location.href = item.donate_url;
            }
        },
        onOpen: function onOpen() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, list, map, goods, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$service.lives.loadList();

                            case 2:
                                _ref = _context.sent;
                                list = _ref.list;
                                map = {};
                                goods = localStorage.getItem('live-goods');

                                if (goods) {
                                    try {
                                        map = JSON.parse(goods);
                                    } catch (e) {}
                                }
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 10;
                                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(list); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    item = _step.value;

                                    item.good = !!map[item.id];
                                }
                                _context.next = 18;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](10);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 18:
                                _context.prev = 18;
                                _context.prev = 19;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 21:
                                _context.prev = 21;

                                if (!_didIteratorError) {
                                    _context.next = 24;
                                    break;
                                }

                                throw _iteratorError;

                            case 24:
                                return _context.finish(21);

                            case 25:
                                return _context.finish(18);

                            case 26:
                                _this.list = list;

                            case 27:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[10, 14, 18, 26], [19,, 21, 25]]);
            }))();
        },
        onRestore: function onRestore() {
            this.onOpen();
        },
        onVote: function onVote(item) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var map, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _item;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!item.good) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.next = 4;
                                return _this2.$service.lives.postVote(item.id);

                            case 4:
                                item.good = true;
                                item.agree++;
                                map = {};
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context2.prev = 10;

                                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this2.list); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    _item = _step2.value;

                                    if (_item.good) {
                                        map[_item.id] = 1;
                                    }
                                }
                                _context2.next = 18;
                                break;

                            case 14:
                                _context2.prev = 14;
                                _context2.t0 = _context2['catch'](10);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context2.t0;

                            case 18:
                                _context2.prev = 18;
                                _context2.prev = 19;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 21:
                                _context2.prev = 21;

                                if (!_didIteratorError2) {
                                    _context2.next = 24;
                                    break;
                                }

                                throw _iteratorError2;

                            case 24:
                                return _context2.finish(21);

                            case 25:
                                return _context2.finish(18);

                            case 26:
                                localStorage.setItem('live-goods', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(map));

                            case 27:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[10, 14, 18, 26], [19,, 21, 25]]);
            }))();
        }
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {}
    };
  },

  computed: {
    prayer: function prayer() {
      return this.$service.other.prayer;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.location.href = 'http://www.fytvapp.com/';
              _context.next = 3;
              return _this.$service.user.loadCurrent();

            case 3:
              _this.user = _context.sent;

              console.info(_this.user);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onShare: function onShare() {
      this.$service.common.share = true;
    },
    onRoute: function onRoute(name) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$service.user.checkUserState(_this2, true);

              case 2:
                if (!_context2.sent) {
                  _context2.next = 4;
                  break;
                }

                _this2.$router.push({ name: name });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_spinner_style_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_spinner_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_spinner_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_spinner__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_spinner__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var n = function n(_n) {
    return _n < 10 ? '0' + _n : _n;
};


function formatedUrl(url) {
    url = url.replace(/https?:\/\/.*?\//, "");
    var i = url.lastIndexOf("?");
    if (i > 0) {
        url = url.substr(0, i);
    }
    return url;
}

/* harmony default export */ __webpack_exports__["default"] = ({
    components: { 'mt-spinner': __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_spinner___default.a },
    props: {
        movie: {}
    },
    data: function data() {
        return {
            audio: false,
            playing: false,
            time: 0,
            duration: 0,
            currentTime: 0,
            touching: false,
            waiting: false,
            title: '',
            src: '',
            first: true,
            fps: '无加速'
        };
    },

    computed: {
        player: function player() {
            if (this.audio) {
                return this.$refs.audio;
            } else {
                return this.$refs.video;
            }
        },
        progress: function progress() {
            return this.currentTime / this.duration;
        },
        style: function style() {
            return {
                left: this.progress * 100 + '%'
            };
        },
        debug: function debug() {
            return window.query.debug;
        }
    },
    filters: {
        secondTime: function secondTime(seconds) {
            var minutes = parseInt(seconds / 60);
            seconds = seconds % 60;
            if (minutes < 60) {
                return n(minutes) + ':' + n(seconds);
            } else {
                var hours = parseInt(minutes / 60);
                minutes = minutes % 60;
                return hours + ':' + n(minutes) + ':' + n(seconds);
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.hls) {
            this.hls.destroy();
        }
    },

    methods: {
        play: function play(resource, auto, audio) {
            if (this.hls) {
                this.hls.destroy();
                this.hls = null;
            }
            this.audio = audio;
            this.time = 0;
            this.title = resource.title;
            this.src = audio ? resource.url_5 : resource.url_1;
            this.channel_id = resource.url_1;
            this.channelid_prefix = Math.random() * Date.now() + '';
            this.ws_signaler = 'wss://signal.p2p.cnfuyin.com';
            this.db_cdn = false;
            this.rewrite_segment_id = 0;
            if (resource.server && !audio) {
                if (resource.server.db_cdn == 'cdnbye') {
                    this.db_cdn = true;
                    this.src = resource.server.cdn_mp4db_url;
                    this.channel_id = resource.server.channel_id;
                    this.channelid_prefix = resource.server.channelid_prefix;
                    this.ws_signaler = resource.server.ws_signaler;
                    this.rewrite_segment_id = resource.server.rewrite_segment_id;
                }
            }
            if (audio || !this.first) {
                this.$nextTick(this.toPlay);
            }
        },
        toPlay: function toPlay() {
            this.player.play();
            this.onWaiting();
        },
        toPause: function toPause() {
            this.player.pause();
        },
        toFullScreen: function toFullScreen() {
            if (this.player.webkitEnterFullScreen) {
                this.player.webkitEnterFullScreen();
            } else if (this.player.requestFullscreen) {
                this.player.requestFullscreen();
            } else if (this.player.webkitRequestFullscreen) {
                this.player.webkitRequestFullscreen();
            } else if (this.player.webkitRequestFullScreen) {
                this.player.webkitRequestFullScreen();
            }
        },
        onPlay: function onPlay() {
            this.playing = true;
            this.first = false;
        },
        onPause: function onPause() {
            this.playing = false;
        },
        onEnd: function onEnd() {
            var _this = this;

            if (window.isIOS) {
                this.$emit('end');
            } else {
                this.player.play();
                this.$nextTick(function () {
                    _this.player.pause();
                    _this.$emit('end');
                });
            }
        },
        onTimeUpdate: function onTimeUpdate() {
            this.playing = !this.player.paused;
            this.waiting = false;
            if (this.touching) {
                return;
            }
            this.duration = parseInt(this.player.duration);
            this.currentTime = parseInt(this.player.currentTime);
        },
        onWaiting: function onWaiting() {
            this.waiting = true;
        },
        onloadedmetadata: function onloadedmetadata() {
            this.duration = parseInt(this.player.duration);
        },
        onTouchStart: function onTouchStart(e) {
            this.touching = true;
            this.from = e.changedTouches[0].clientX;
            this.last = this.progress;
        },
        onTouchMove: function onTouchMove(e) {
            if (this.touching) {
                var width = this.$refs.track.clientWidth;
                var offset = e.changedTouches[0].clientX - this.from;
                var left = offset / width + this.last;
                if (left < 0) {
                    left = 0;
                } else if (left > 1) {
                    left = 1;
                }
                this.currentTime = parseInt(this.duration * left);
            }
        },
        onTouchEnd: function onTouchEnd(e) {
            if (this.touching) {
                this.player.currentTime = this.currentTime;
            }
            this.touching = false;
        }
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    player: {}
  },
  computed: {
    list: function list() {
      return this.$service.movie.movie.urls;
    }
  },
  methods: {
    onPlayVideo: function onPlayVideo(index, auto) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$service.user.checkUserState(_this, false, true);

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this.$emit('video', { index: index, auto: auto });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onPlayAudio: function onPlayAudio(index) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$service.user.checkUserState(_this2, false, true);

              case 2:
                if (!_context2.sent) {
                  _context2.next = 4;
                  break;
                }

                _this2.$emit('audio', index);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onDownloadAudio: function onDownloadAudio(index) {
      this.$emit('download-audio', index);
    },
    onDownloadPdf: function onDownloadPdf(index) {
      this.$emit('pdf', index);
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    favourite: {}
  },
  methods: {
    onFav: function onFav() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$service.user.checkUserState(_this, true);

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                _this.$emit('favourite');

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onNote: function onNote() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$service.user.checkUserState(_this2, true);

              case 2:
                if (!_context2.sent) {
                  _context2.next = 4;
                  break;
                }

                _this2.$emit('note');

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MovieVideo_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MovieVideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MovieVideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlayList_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlayList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PlayList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toolbar_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Toolbar_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: { AppView: __WEBPACK_IMPORTED_MODULE_3__components_AppView_vue___default.a, AppConfirm: __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default.a, MovieVideo: __WEBPACK_IMPORTED_MODULE_4__MovieVideo_vue___default.a, Toolbar: __WEBPACK_IMPORTED_MODULE_6__Toolbar_vue___default.a, PlayList: __WEBPACK_IMPORTED_MODULE_5__PlayList_vue___default.a },
    data: function data() {
        return {
            current: {},
            intro: false,
            favourite: false,
            ready: false,
            player: {
                index: -1,
                video: false,
                audio: false
            },
            download: true
        };
    },

    computed: {
        share: function share() {
            return this.$service.common.share;
        },
        movid: function movid() {
            return this.$route.params.movid;
        },
        urlid: function urlid() {
            return parseInt(this.$route.query.urlid);
        },
        isAudio: function isAudio() {
            return this.$route.query.audio === '1';
        },
        movie: function movie() {
            return this.$service.movie.movie;
        },
        height169: function height169() {
            return window.innerWidth * 9 / 16;
        }
    },
    methods: {
        onGoAd: function onGoAd() {
            this.$service.other.goItem(this.movie.zs, this.$router);
        },
        getResource: function getResource(item) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!item.resource) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return', item.resource);

                            case 4:
                                _context.next = 6;
                                return _this.$service.movie.getUrl(item.urlid, _this.movid);

                            case 6:
                                item.resource = _context.sent;
                                return _context.abrupt('return', item.resource);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onClickPlayVideo: function onClickPlayVideo(_ref) {
            var _this2 = this;

            var index = _ref.index,
                auto = _ref.auto;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var item;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                // if (await this.$refs.confirm.show('下载福音TV APP播放更流畅', { ok: '现在下载', cancel: '暂时不用' })) {
                                //     window.location = 'http://www.fytvapp.com'
                                //     return
                                // }
                                item = _this2.movie.urls[index];

                                if (item.mp4) {
                                    _this2.onPlayVideo(index, true);
                                } else {
                                    if (auto) {
                                        _this2.onPlayAudio(index, true);
                                    } else {
                                        _this2.$toast('暂时没有这个资源');
                                    }
                                }

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        onPlayVideo: function onPlayVideo(index) {
            var _this3 = this;

            var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var item, resource;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                item = _this3.movie.urls[index];

                                if (!(_this3.player.index === index && _this3.player.video)) {
                                    _context3.next = 4;
                                    break;
                                }

                                _this3.$service.wechat.callShare({
                                    title: _this3.movie.title + item.sort_title,
                                    link: window.location.origin + '/#movie/' + _this3.movid + '?urlid=' + item.urlid,
                                    imgUrl: _this3.movie.pic
                                });
                                return _context3.abrupt('return');

                            case 4:
                                if (!item.mp4) {
                                    _context3.next = 14;
                                    break;
                                }

                                _context3.next = 7;
                                return _this3.getResource(item);

                            case 7:
                                resource = _context3.sent;

                                _this3.player = {
                                    index: index,
                                    video: true,
                                    audio: false
                                };
                                _this3.current = item;
                                _this3.$refs.video.play(resource, auto, false);
                                _this3.$service.wechat.callShare({
                                    title: _this3.movie.title + item.sort_title,
                                    link: window.location.origin + '/#movie/' + _this3.movid + '?urlid=' + item.urlid,
                                    imgUrl: _this3.movie.pic
                                });
                                _context3.next = 15;
                                break;

                            case 14:
                                _this3.onPlayAudio(index, auto);

                            case 15:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        onPlayAudio: function onPlayAudio(index) {
            var _this4 = this;

            var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var item, resource;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                item = _this4.movie.urls[index];

                                if (!(_this4.player.index === index && _this4.player.audio)) {
                                    _context4.next = 4;
                                    break;
                                }

                                _this4.$service.wechat.callShare({
                                    title: _this4.movie.title + item.sort_title,
                                    link: window.location.origin + '/#movie/' + _this4.movid + '?urlid=' + item.urlid,
                                    imgUrl: _this4.movie.pic
                                });
                                return _context4.abrupt('return');

                            case 4:
                                _context4.next = 6;
                                return _this4.getResource(item);

                            case 6:
                                resource = _context4.sent;

                                _this4.player = {
                                    index: index,
                                    video: false,
                                    audio: true
                                };
                                _this4.current = item;
                                _this4.$refs.video.play(resource, auto, true);
                                _this4.$service.wechat.callShare({
                                    title: _this4.movie.title + item.sort_title,
                                    link: window.location.origin + '/#movie/' + _this4.movid + '?urlid=' + item.urlid,
                                    imgUrl: _this4.movie.pic
                                });

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        onDownloadAudio: function onDownloadAudio(index) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var item, resource;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                item = _this5.movie.urls[index];
                                _context5.next = 3;
                                return _this5.getResource(item);

                            case 3:
                                resource = _context5.sent;

                                window.location.href = resource.url_6;

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        onDownloadPdf: function onDownloadPdf(index) {
            var item = this.movie.urls[index];
            if (item.doc) {
                window.location.href = 'https://www.ifuyin.com/index.php/content/downfile/urlid/' + item.urlid + '/type/4/';
            } else {
                this.$toast('暂时没有这个资源');
            }
        },
        onIntro: function onIntro() {
            this.intro = true;
        },
        onList: function onList() {
            this.intro = false;
        },
        onFavourite: function onFavourite() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!_this6.favourite) {
                                    _context6.next = 6;
                                    break;
                                }

                                _context6.next = 3;
                                return _this6.$service.user.removeFavourite(_this6.favourite.id);

                            case 3:
                                _this6.favourite = false;
                                _context6.next = 9;
                                break;

                            case 6:
                                _context6.next = 8;
                                return _this6.$service.user.addFavourite(_this6.movie);

                            case 8:
                                _this6.favourite = _context6.sent;

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        onNote: function onNote() {
            var item = this.movie.urls[this.player.index];
            this.$router.push({
                name: 'note-editor',
                params: {
                    movid: this.movid,
                    urlid: item.urlid
                },
                query: {
                    m: this.movie.title,
                    t: item.title
                }
            });
        },
        onOpen: function onOpen() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var index, item;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this7.$service.user.isFavourite(_this7.movid);

                            case 2:
                                _this7.favourite = _context7.sent;
                                _context7.next = 5;
                                return _this7.$service.movie.loadMovie(_this7.movid);

                            case 5:
                                _this7.$service.common.title = _this7.movie.title;
                                index = 0;

                                if (_this7.urlid > 0) {
                                    index = _this7.movie.urls.findIndex(function (item) {
                                        return item.urlid === _this7.urlid;
                                    });
                                }
                                item = _this7.movie.urls[index];

                                _this7.url = 'fuyintv://tv/movie?movid=' + _this7.movid + '&urlid=' + item.urlid;
                                window.location.href = _this7.url;

                                document.body.scrollTop = index * 44;

                                if (_this7.isAudio) {
                                    _this7.onPlayAudio(index, false);
                                } else {
                                    _this7.onPlayVideo(index, false);
                                }
                                _this7.download = true;
                                setTimeout(function () {
                                    _this7.ready = true;
                                }, 3000);
                                // if (await this.$refs.confirm.show('下载福音TV APP播放更流畅', { ok: '现在下载', cancel: '暂时不用' })) {
                                //     window.location = 'http://www.fytvapp.com'
                                //     return
                                // }
                                _this7.$service.user.closeSubscribe();

                            case 16:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },
        onRestore: function onRestore() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!_this8.movie.movid) {
                                    _context8.next = 7;
                                    break;
                                }

                                _context8.next = 3;
                                return _this8.$service.user.isFavourite(_this8.movid);

                            case 3:
                                _this8.favourite = _context8.sent;

                                _this8.$service.common.title = _this8.movie.title;
                                _context8.next = 8;
                                break;

                            case 7:
                                _this8.onOpen();

                            case 8:
                                _this8.download = true;
                                setTimeout(function () {
                                    _this8.download = false;
                                }, 3000);

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        },
        onClose: function onClose() {
            var item = this.movie.urls[this.player.index];
            var time = this.$refs.video.time;
            this.$service.movie.clearMovie();
            this.intro = false;
            this.favourite = false;
            this.ready = false;
            this.player = {
                index: -1,
                video: false,
                audio: false
            };
        },
        onPlayEnd: function onPlayEnd() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return _this9.$service.user.checkUserState(_this9, false, true);

                            case 2:
                                if (!_context9.sent) {
                                    _context9.next = 4;
                                    break;
                                }

                                _this9.onPlayEnd3();

                            case 4:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this9);
            }))();
        },
        onPlayEnd3: function onPlayEnd3() {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (_this10.urlid > 0) {} else {
                                    if (_this10.player.index < _this10.movie.urls.length - 1) {
                                        _this10.onPlayVideo(_this10.player.index + 1, true);
                                    }
                                }

                            case 1:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this10);
            }))();
        },
        onPlayEnd2: function onPlayEnd2() {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var tip;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                tip = '暂时不用';

                                if (_this11.urlid > 0) {} else {
                                    if (_this11.player.index < _this11.movie.urls.length - 1) {
                                        tip = '继续播放';
                                    }
                                }
                                _context11.next = 4;
                                return _this11.$refs.confirm.show('下载福音app 体验更多功能', { ok: '点击下载', cancel: tip });

                            case 4:
                                if (!_context11.sent) {
                                    _context11.next = 8;
                                    break;
                                }

                                window.location = 'http://www.fytvapp.com';
                                _context11.next = 9;
                                break;

                            case 8:
                                if (_this11.urlid > 0) {} else {
                                    if (_this11.player.index < _this11.movie.urls.length - 1) {
                                        _this11.onPlayVideo(_this11.player.index + 1, true);
                                    }
                                }

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this11);
            }))();
        },
        onCloseDownload: function onCloseDownload() {
            this.download = false;
        },
        onOpenDownload: function onOpenDownload() {
            this.download = true;
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__);


//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, HtmlContent: __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default.a },
  data: function data() {
    return {
      value: {}
    };
  },

  computed: {
    id: function id() {
      return this.$route.params.id;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.news.loadDetail(_this.id);

            case 2:
              _this.value = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_List_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_List_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_0__components_AppView_vue___default.a, List: __WEBPACK_IMPORTED_MODULE_1__components_List_vue___default.a },
  data: function data() {
    return {
      types: ['站内公告', '最新动态']
    };
  },

  computed: {
    type: function type() {
      return this.$service.news.type;
    },
    list: function list() {
      return this.$service.news.list;
    }
  },
  methods: {
    onSwitch: function onSwitch(type) {
      this.$service.news.type = type;
      this.$service.common.title = this.types[type];
      this.$refs.list.reload();
    },
    clear: function clear() {
      this.$service.news.clear();
    },
    loadNextPage: function loadNextPage() {
      this.$service.news.loadNext();
    },
    onOpen: function onOpen() {
      this.onSwitch(0);
    },
    onRestore: function onRestore() {
      if (this.list.length === 0) {
        this.onOpen();
      } else {
        this.$service.common.title = this.types[this.type];
      }
    },
    onClose: function onClose() {
      this.$service.news.clear();
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a },
  data: function data() {
    return {
      item: {}
    };
  },

  computed: {
    movid: function movid() {
      return this.$route.params.movid;
    },
    urlid: function urlid() {
      return this.$route.params.urlid;
    }
  },
  methods: {
    onOpen: function onOpen() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$service.user.getNote(_this.movid, _this.urlid);

              case 3:
                _this.item = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this.item = {
                  title: _this.$route.query.m || '',
                  subtitle: _this.$route.query.t || '',
                  content: ''
                };

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.item.subtitle) {
                  _context2.next = 3;
                  break;
                }

                _this2.$toast('请填写标题');
                return _context2.abrupt('return');

              case 3:
                if (_this2.item.content) {
                  _context2.next = 6;
                  break;
                }

                _this2.$toast('请填写内容');
                return _context2.abrupt('return');

              case 6:
                if (!_this2.item.id) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this2.$service.user.updateNode(_this2.item.id, _this2.item.title, _this2.item.subtitle, _this2.item.content);

              case 9:
                _context2.next = 13;
                break;

              case 11:
                _context2.next = 13;
                return _this2.$service.user.addNote(_this2.movid, _this2.urlid, _this2.item.title, _this2.item.subtitle, _this2.item.content);

              case 13:
                _this2.$toast('保存成功');
                _this2.$router.go(-1);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppConfirm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppConfirm_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppConfirm: __WEBPACK_IMPORTED_MODULE_3__components_AppConfirm_vue___default.a },
  data: function data() {
    return {
      notes: {},
      tap: 0
    };
  },

  computed: {
    none: function none() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.notes).length === 0;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.user.getNotes();

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              _this.notes = data;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onTouchStart: function onTouchStart(i) {
      var _this2 = this;

      this.tap = setTimeout(function () {
        _this2.onDelete(i);
      }, 1000);
    },
    onTouchEnd: function onTouchEnd() {
      clearTimeout(this.tap);
    },
    onDelete: function onDelete(i) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var item;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$refs.confirm.show('您确定要删除该笔记吗?');

              case 2:
                if (!_context2.sent) {
                  _context2.next = 7;
                  break;
                }

                item = _this3.notes[i];
                _context2.next = 6;
                return _this3.$service.user.removeNote(item.id);

              case 6:
                _this3.notes.splice(i, 1);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onEdit: function onEdit(i) {
      var item = this.notes[i];
      this.$router.push({
        name: 'note-editor',
        params: {
          movid: item.tid,
          urlid: item.urlid
        }
      });
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.other.getPay();

            case 2:
              _this.info = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__areas__ = __webpack_require__(157);






 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            phone: '',
            code: '',
            cold: 0,
            ignore: false,
            areas: __WEBPACK_IMPORTED_MODULE_5__areas__["a" /* default */],
            area: '86',
            areaVisible: false,
            isWechat: false
        };
    },

    computed: {
        tip: function tip() {
            return this.$route.query.tip;
        }
    },
    mounted: function mounted() {
        this.isWechat = window.isWechat;
        this.$service.user.isSettingReady(this.onReady);
    },

    methods: {
        onReady: function onReady() {
            this.ignore = this.$service.user.setting.h5_bind_mobile_ignore;
        },
        onSendCode: function onSendCode() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.phone) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()('请输入手机号'));

                            case 2:
                                if (/^1\d{10}$/.test(_this.phone)) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()('手机号码格式不正确'));

                            case 4:
                                _context.next = 6;
                                return _this.$service.user.getPhoneCode(_this.phone);

                            case 6:
                                if (!(_this.cold > 0)) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 8:
                                _this.cold = 60;
                                _this.onTimer();

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onTimer: function onTimer() {
            this.cold--;
            if (this.cold > 0) {
                setTimeout(this.onTimer, 1000);
            }
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.phone) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()('请输入手机号'));

                            case 2:
                                if (/^1\d{10}$/.test(_this2.phone)) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()('手机号码格式不正确'));

                            case 4:
                                if (_this2.code) {
                                    _context2.next = 6;
                                    break;
                                }

                                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()('请输入验证码'));

                            case 6:
                                if (!_this2.isWechat) {
                                    _context2.next = 11;
                                    break;
                                }

                                _context2.next = 9;
                                return _this2.$service.user.bindPhone(_this2.phone, _this2.code, _this2.area);

                            case 9:
                                _context2.next = 13;
                                break;

                            case 11:
                                _context2.next = 13;
                                return _this2.$service.user.loginByPhone(_this2.phone, _this2.code, _this2.area);

                            case 13:
                                _context2.next = 15;
                                return _this2.$service.user.checkUserState(_this2, true);

                            case 15:
                                if (!_context2.sent) {
                                    _context2.next = 17;
                                    break;
                                }

                                _this2.$service.user.goReturn(_this2);

                            case 17:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        onCancel: function onCancel() {
            this.$service.user.goReturn(this, true);
        },
        onScrollTo: function onScrollTo(k) {
            var _this3 = this;

            var y = 0;
            var i = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.areas).findIndex(function (i) {
                if (i == k) {
                    return true;
                } else {
                    y += (_this3.areas[i].length + 1) * 40;
                    return false;
                }
            });
            this.$refs.areas.scrollTop = y;
        },
        onChooseArea: function onChooseArea(item) {
            this.area = item.c;
            this.areaVisible = false;
        }
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppConfirm: __WEBPACK_IMPORTED_MODULE_2__components_AppConfirm_vue___default.a },
  data: function data() {
    return {
      list: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.user.getPlaybacks();

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              data.forEach(function (d) {
                d.pic = d.thumb;
                d.movid = d.tid;
              });
              _this.list = data;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onSelected: function onSelected(item) {
      this.$router.push({
        name: 'movie',
        params: {
          movid: item.movid
        },
        query: {
          urlid: item.urlid
        }
      });
    },
    onLongTap: function onLongTap(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$refs.confirm.show('您确定要删除该播放记录?');

              case 2:
                if (!_context2.sent) {
                  _context2.next = 8;
                  break;
                }

                index = _this2.list.indexOf(item);

                if (!(index >= 0)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return _this2.$service.user.removePlayback(item.id);

              case 7:
                _this2.list.splice(index, 1);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue__);


//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, HtmlContent: __WEBPACK_IMPORTED_MODULE_3__components_HtmlContent_vue___default.a },
  data: function data() {
    return {
      value: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$service.other.getPrayerSupport();

            case 2:
              _this.value = _context.sent;

              _this.$service.user.readPrayer(_this.value.dateline);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AppView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_List_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_List_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_2__components_AppView_vue___default.a, MovieCover: __WEBPACK_IMPORTED_MODULE_3__components_MovieCover_vue___default.a, List: __WEBPACK_IMPORTED_MODULE_4__components_List_vue___default.a },
  data: function data() {
    return {
      history: [],
      value: '',
      timeout: false,
      searchOnce: false
    };
  },

  computed: {
    bookshelf: function bookshelf() {
      return this.$service.movie.bookshelf;
    },
    query: function query() {
      return this.$service.movie.searchQuery;
    },
    first: function first() {
      return this.$route.query.key;
    }
  },
  watch: {
    value: function value(val) {
      var _this = this;

      if (val) {
        if (!this.timeout) {
          this.timeout = true;
          setTimeout(function () {
            _this.onSearch(_this.value);
            _this.timeout = false;
          }, 1000);
        }
      } else {
        this.clear();
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  mounted: function mounted() {
    console.info('---', this.first);
    if (this.first) {
      this.value = this.first;
      this.onSearch(this.first);
    }
  },

  methods: {
    onSearch: function onSearch(value) {
      var _this2 = this;

      if (this.query !== value) {
        this.value = value;
        this.$service.movie.searchQuery = value;
        if (value) {
          this.$nextTick(function () {
            _this2.$refs.list.reload();
          });
        }
      }
    },
    onClearText: function onClearText() {
      this.value = '';
      this.$service.movie.searchQuery = '';
      this.searchOnce = false;
    },
    clear: function clear() {
      this.$service.movie.clearBookShelf();
    },
    loadNext: function loadNext() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$service.movie.searchBookShelf();

              case 2:
                _this3.searchOnce = true;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    onSelected: function onSelected(item) {
      this.$service.user.addSearchHistory(item.title);
      this.$router.push({
        name: 'movie',
        params: {
          movid: item.movid
        }
      });
    },
    onOpen: function onOpen() {
      this.history = this.$service.user.getSearchHistory();
    },
    onRestore: function onRestore() {
      this.value = this.query;
      this.history = this.$service.user.getSearchHistory();
    },
    onClose: function onClose() {
      this.clear();
      this.$service.movie.searchQuery = '';
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      qrcode: '',
      ignore: false
    };
  },

  computed: {
    tip: function tip() {
      return this.$route.query.tip;
    }
  },
  mounted: function mounted() {
    this.$service.user.isSettingReady(this.onReady);
  },

  methods: {
    onReady: function onReady() {
      this.qrcode = this.$service.user.setting.h5_force_qrcode;
      this.ignore = this.$service.user.setting.h5_subscribe_ignore;
    },
    onCancel: function onCancel() {
      this.$service.user.goReturn(this, true);
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppView_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AppView_vue__);




//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AppView: __WEBPACK_IMPORTED_MODULE_4__components_AppView_vue___default.a },
  data: function data() {
    return {
      content: '',
      contact: ''
    };
  },

  methods: {
    onSend: function onSend() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.content.length === 0)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()('请填写您的建议反馈');
                return _context.abrupt('return');

              case 3:
                if (!(_this.contact.length === 0)) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()('请填写您的联系方式');
                return _context.abrupt('return');

              case 6:
                _context.next = 8;
                return _this.$service.other.sendSuggest({
                  content: _this.content,
                  contact: _this.contact
                });

              case 8:
                __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()('提交成功');
                _this.$router.go(-1);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: true
        };
    },

    props: {
        disable: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_base_scss__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_base_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_filters__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_App_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_App_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__util_filters__["a" /* default */]);

var m = window.navigator.userAgent.match(/(android|ios)\/tv\.fuyin\/(.+?)$/);
if (m) {
  window.inApp = true;
  window.app = m[1];
  window.appVersion = m[2];
}
window.isM = window.location.href.indexOf('mfuyin.tv/') >= 0;

var parseQuery = function parseQuery() {
  if (window.location.search) {
    return window.location.search.substr(1).split('&').map(function (q) {
      return q.split('=');
    }).reduce(function (map, q) {
      map[q[0]] = q[1];
      return map;
    }, {});
  } else {
    return {};
  }
};

function next(err) {
  if (err) {
    console.error(err);
  }
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_7__view_App_vue___default.a }
  });
}

var params = parseQuery();
__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].user.token = params.token;
window.query = params;
if (window.wx) {
  next();
  // service.wechat.sign(params).then(next).catch(next)
} else {
  next();
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BaseService__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_decorators__ = __webpack_require__(12);









var _dec, _dec2, _dec3, _dec4, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





var CategoryService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_decorators__["b" /* toast */])(), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_decorators__["b" /* toast */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_decorators__["b" /* toast */])('获取牧者列表失败'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(CategoryService, _BaseService);

  function CategoryService() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, CategoryService);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CategoryService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(CategoryService)).call(this, {
      roots: [],
      all: [],
      priest: [],
      bible: []
    }));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(CategoryService, [{
    key: 'loadRootCategories',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.data.roots.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].category.getPage();

              case 3:
                this.data.roots = _context.sent;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadRootCategories() {
        return _ref.apply(this, arguments);
      }

      return loadRootCategories;
    }()
  }, {
    key: 'loadAllCategories',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.data.all.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].category.getAll();

              case 3:
                this.data.all = _context2.sent;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadAllCategories() {
        return _ref2.apply(this, arguments);
      }

      return loadAllCategories;
    }()
  }, {
    key: 'loadPriests',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.data.priest.length === 0)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].category.getMZZL();

              case 3:
                this.data.priest = _context3.sent;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadPriests() {
        return _ref3.apply(this, arguments);
      }

      return loadPriests;
    }()
  }, {
    key: 'loadBible',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.data.bible.length === 0)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].category.getBible();

              case 3:
                this.data.bible = _context4.sent;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadBible() {
        return _ref4.apply(this, arguments);
      }

      return loadBible;
    }()
  }, {
    key: 'roots',
    get: function get() {
      return this.data.roots;
    }
  }, {
    key: 'all',
    get: function get() {
      return this.data.all;
    }
  }, {
    key: 'priest',
    get: function get() {
      return this.data.priest;
    }
  }, {
    key: 'bible',
    get: function get() {
      return this.data.bible;
    }
  }]);

  return CategoryService;
}(__WEBPACK_IMPORTED_MODULE_8__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadRootCategories', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadRootCategories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadAllCategories', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadAllCategories'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadPriests', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadPriests'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadBible', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadBible'), _class.prototype)), _class));


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseService__ = __webpack_require__(18);







var CommonService = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CommonService, _BaseService);

  function CommonService() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CommonService);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CommonService.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CommonService)).call(this, {
      title: '',
      menu: false,
      info: false,
      tool: false,
      share: false
    }));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CommonService, [{
    key: 'share',
    get: function get() {
      return this.data.share;
    },
    set: function set(value) {
      this.data.share = value;
    }
  }, {
    key: 'tool',
    get: function get() {
      return this.data.tool;
    },
    set: function set(value) {
      this.data.tool = value;
    }
  }, {
    key: 'info',
    get: function get() {
      return this.data.info;
    },
    set: function set(value) {
      this.data.info = value;
    }
  }, {
    key: 'title',
    get: function get() {
      return this.data.title;
    },
    set: function set(value) {
      this.data.title = value;
    }
  }, {
    key: 'menu',
    get: function get() {
      return this.data.menu;
    },
    set: function set(value) {
      this.data.menu = value;
    }
  }, {
    key: 'noHead',
    get: function get() {
      return window.isWechat;
    }
  }]);

  return CommonService;
}(__WEBPACK_IMPORTED_MODULE_5__BaseService__["a" /* default */]);



/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LiveService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BaseService__ = __webpack_require__(18);









var _dec, _dec2, _dec3, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}





var LiveService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_decorators__["b" /* toast */])(), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_decorators__["b" /* toast */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(LiveService, _BaseService);

    function LiveService() {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, LiveService);

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LiveService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(LiveService)).call(this, {}));
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LiveService, [{
        key: 'loadList',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].lives.getLiveRooms(1, 20);

                            case 2:
                                return _context.abrupt('return', _context.sent);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadList() {
                return _ref.apply(this, arguments);
            }

            return loadList;
        }()
    }, {
        key: 'getDetail',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].lives.getLiveDetail(id);

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getDetail(_x) {
                return _ref2.apply(this, arguments);
            }

            return getDetail;
        }()
    }, {
        key: 'postVote',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].lives.postVote(id);

                            case 2:
                                return _context3.abrupt('return', _context3.sent);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function postVote(_x2) {
                return _ref3.apply(this, arguments);
            }

            return postVote;
        }()
    }, {
        key: 'postHit',
        value: function postHit(ac, id) {
            return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].lives.postHit(ac, id);
        }
    }]);

    return LiveService;
}(__WEBPACK_IMPORTED_MODULE_10__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadList', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDetail', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getDetail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'postVote', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'postVote'), _class.prototype)), _class));


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BaseService__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12____ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_decorators__ = __webpack_require__(12);











var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var MovieService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])('搜索影片失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), _dec6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), _dec7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(MovieService, _BaseService);

  function MovieService() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, MovieService);

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MovieService.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(MovieService)).call(this, {
      bookshelf: [],
      bookshelfPage: 0,
      bookshelfPageSize: 48,
      searchQuery: '',
      movie: {
        zs: {}
      }
    }));
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(MovieService, [{
    key: 'clearBookShelf',
    value: function clearBookShelf() {
      this.data.bookshelf = [];
      this.data.bookshelfPage = 0;
    }
  }, {
    key: 'clearMovie',
    value: function clearMovie() {
      this.data.movie = {};
    }
  }, {
    key: 'searchBookShelf',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadBookShelf({ kw: this.searchQuery });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function searchBookShelf() {
        return _ref.apply(this, arguments);
      }

      return searchBookShelf;
    }()
  }, {
    key: 'loadBookShelfByRecommendation',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(value === 2)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return this.loadBookShelf({ order: 0 });

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.next = 7;
                return this.loadBookShelf({ recmd: value });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadBookShelfByRecommendation(_x) {
        return _ref2.apply(this, arguments);
      }

      return loadBookShelfByRecommendation;
    }()
  }, {
    key: 'loadBookShelfByCategory',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(catid) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loadBookShelf({ catid: catid });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadBookShelfByCategory(_x2) {
        return _ref3.apply(this, arguments);
      }

      return loadBookShelfByCategory;
    }()
  }, {
    key: 'loadBookShelfByBible',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(bid) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.loadBookShelf({ bible_id: bid });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadBookShelfByBible(_x3) {
        return _ref4.apply(this, arguments);
      }

      return loadBookShelfByBible;
    }()
  }, {
    key: 'loadBookShelf',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(params) {
        var body;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].movie.getPage(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(params, {
                  page: this.data.bookshelfPage + 1,
                  pagesize: this.data.bookshelfPageSize
                }));

              case 2:
                body = _context5.sent;

                if (!params.kw || params.kw === this.searchQuery) {
                  if (this.data.bookshelfPage === 0) {
                    this.data.bookshelf = body.data;
                  } else {
                    this.data.bookshelf = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.data.bookshelf), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(body.data));
                  }
                  if (body.data.length > 0) {
                    this.data.bookshelfPage++;
                  }
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadBookShelf(_x4) {
        return _ref5.apply(this, arguments);
      }

      return loadBookShelf;
    }()
  }, {
    key: 'loadMovie',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(movid) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].movie.getDetail({ movid: movid });

              case 2:
                this.data.movie = _context6.sent;

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadMovie(_x5) {
        return _ref6.apply(this, arguments);
      }

      return loadMovie;
    }()
  }, {
    key: 'getUrl',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(urlid, movid) {
        var body;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].movie.getResource({ urlid: urlid, movid: movid, token: __WEBPACK_IMPORTED_MODULE_12____["a" /* default */].user._token });

              case 2:
                body = _context7.sent;

                body.url_1 = encodeURI(body.url_1);
                body.url_2 = encodeURI(body.url_2);
                body.url_5 = encodeURI(body.url_5);
                body.url_6 = encodeURI(body.url_6);
                return _context7.abrupt('return', body);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUrl(_x6, _x7) {
        return _ref7.apply(this, arguments);
      }

      return getUrl;
    }()
  }, {
    key: 'loadLatest',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].movie.getTops();

              case 2:
                return _context8.abrupt('return', _context8.sent);

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function loadLatest() {
        return _ref8.apply(this, arguments);
      }

      return loadLatest;
    }()
  }, {
    key: 'bookshelf',
    get: function get() {
      return this.data.bookshelf;
    }
  }, {
    key: 'searchQuery',
    get: function get() {
      return this.data.searchQuery;
    },
    set: function set(value) {
      this.data.searchQuery = value;
    }
  }, {
    key: 'movie',
    get: function get() {
      return this.data.movie;
    }
  }]);

  return MovieService;
}(__WEBPACK_IMPORTED_MODULE_10__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'searchBookShelf', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'searchBookShelf'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadBookShelfByRecommendation', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadBookShelfByRecommendation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadBookShelfByCategory', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadBookShelfByCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadBookShelfByBible', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadBookShelfByBible'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadMovie', [_dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadMovie'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getUrl', [_dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getUrl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadLatest', [_dec7], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadLatest'), _class.prototype)), _class));


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BaseService__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10____ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_decorators__ = __webpack_require__(12);










var _dec, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var NewsService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(NewsService, _BaseService);

  function NewsService() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, NewsService);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NewsService.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(NewsService)).call(this, {
      list: [],
      type: 0,
      page: 0,
      pageSize: 20,
      news: 0
    }));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(NewsService, [{
    key: 'clear',
    value: function clear() {
      this.data.list = [];
      this.data.page = 0;
    }
  }, {
    key: 'loadNext',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].news.getPage({
                  type: this.type,
                  page: this.data.page + 1,
                  pagesize: this.data.pageSize
                });

              case 2:
                body = _context.sent;

                if (this.data.page === 0) {
                  this.data.list = body.data;
                } else {
                  this.data.list = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.data.list), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(body.data));
                }
                this.data.page++;
                if (this.data.list.length > 0 && this.data.list[0].addtime > __WEBPACK_IMPORTED_MODULE_10____["a" /* default */].user.getLastNews()) {
                  this.data.news = this.data.list[0].addtime;
                  __WEBPACK_IMPORTED_MODULE_10____["a" /* default */].user.readLastNews(this.data.news);
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadNext() {
        return _ref.apply(this, arguments);
      }

      return loadNext;
    }()
  }, {
    key: 'loadDetail',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].news.getDetail({ id: id });

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadDetail(_x) {
        return _ref2.apply(this, arguments);
      }

      return loadDetail;
    }()
  }, {
    key: 'loadNews',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var body;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].news.getPage({ page: 1, pagesize: 1 });

              case 2:
                body = _context3.sent;

                if (body.data.length > 0) {
                  this.data.news = body.data[0].addtime;
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadNews() {
        return _ref3.apply(this, arguments);
      }

      return loadNews;
    }()
  }, {
    key: 'list',
    get: function get() {
      return this.data.list;
    }
  }, {
    key: 'type',
    get: function get() {
      return this.data.type;
    },
    set: function set(value) {
      this.data.type = value;
    }
  }, {
    key: 'unread',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_10____["a" /* default */].user.getLastNews() < this.data.news;
    }
  }]);

  return NewsService;
}(__WEBPACK_IMPORTED_MODULE_9__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadNext', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadNext'), _class.prototype)), _class));


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OtherService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8____ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BaseService__ = __webpack_require__(18);









var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var OtherService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), _dec6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(OtherService, _BaseService);

  function OtherService() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, OtherService);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OtherService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(OtherService)).call(this, {
      setting: {
        prayerSupport: {},
        index_menu: [],
        index_ad: {}
      },
      banner: [],
      recommendations: []
    }));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(OtherService, [{
    key: 'loadSetting',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.getSetting();

              case 2:
                this.data.setting = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadSetting() {
        return _ref.apply(this, arguments);
      }

      return loadSetting;
    }()
  }, {
    key: 'loadBanners',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.getBanners({
                  pagesize: 6
                });

              case 2:
                this.data.banner = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadBanners() {
        return _ref2.apply(this, arguments);
      }

      return loadBanners;
    }()
  }, {
    key: 'loadHomeRecommendations',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].category.getRecommendations();

              case 2:
                this.data.recommendations = _context3.sent;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadHomeRecommendations() {
        return _ref3.apply(this, arguments);
      }

      return loadHomeRecommendations;
    }()
  }, {
    key: 'sendSuggest',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5) {
        var content = _ref5.content,
            contact = _ref5.contact;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.feedback({
                  content: content,
                  contact: contact
                });

              case 2:
                return _context4.abrupt('return', _context4.sent);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sendSuggest(_x) {
        return _ref4.apply(this, arguments);
      }

      return sendSuggest;
    }()
  }, {
    key: 'getPrayerSupport',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.getPrayerSupport({
                  nohtml: 0
                });

              case 2:
                return _context5.abrupt('return', _context5.sent);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getPrayerSupport() {
        return _ref6.apply(this, arguments);
      }

      return getPrayerSupport;
    }()
  }, {
    key: 'loadAbout',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.getAbout({
                  nohtml: 0
                });

              case 2:
                return _context6.abrupt('return', _context6.sent);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadAbout() {
        return _ref7.apply(this, arguments);
      }

      return loadAbout;
    }()
  }, {
    key: 'getPay',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].other.getPaySetting();

              case 2:
                return _context7.abrupt('return', _context7.sent);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPay() {
        return _ref8.apply(this, arguments);
      }

      return getPay;
    }()
  }, {
    key: 'goItem',
    value: function goItem(item, router) {
      if (item.target === 'webview' || item.target === 'browser') {
        window.location.href = item.linkurl;
      } else if (item.target === 'movie') {
        var route = {
          name: 'movie',
          params: {
            movid: item.movid
          }
        };
        if (item.urlid) {
          route.query = {
            urlid: item.urlid
          };
        }
        router.push(route);
      } else if (item.target === 'category') {
        router.push({
          name: 'bookshelf',
          params: {
            catid: item.catid
          },
          query: {
            catname: item.name
          }
        });
      } else if (item.target === 'activity') {
        switch (item.page) {
          case 'update':
            return router.push({
              name: 'latest',
              query: {
                recmd: 2,
                name: '最近更新'
              }
            });
          case 'actor':
            return router.push({
              name: 'category-priest'
            });
          case 'recommend':
            return router.push({
              name: 'bookshelf',
              query: {
                recmd: 3,
                name: '推荐视频'
              }
            });
          case 'hot':
            return router.push({
              name: 'bookshelf',
              query: {
                recmd: 1,
                name: '热门视频'
              }
            });
          case 'bible':
            return router.push({
              name: 'bible'
            });
        }
      } else if (item.target === 'miniprogram') {
        window.location.href = item.url;
      }
    }
  }, {
    key: 'setting',
    get: function get() {
      return this.data.setting;
    }
  }, {
    key: 'banner',
    get: function get() {
      return this.data.banner;
    }
  }, {
    key: 'prayer',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_8____["a" /* default */].user.getPrayer() !== this.data.setting.prayerSupport.dateline;
    }
  }, {
    key: 'recommendations',
    get: function get() {
      return this.data.recommendations;
    }
  }]);

  return OtherService;
}(__WEBPACK_IMPORTED_MODULE_11__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadSetting', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadSetting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadBanners', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadBanners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadHomeRecommendations', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadHomeRecommendations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sendSuggest', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'sendSuggest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getPrayerSupport', [_dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getPrayerSupport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadAbout', [_dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadAbout'), _class.prototype)), _class));


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_cache__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BaseService__ = __webpack_require__(18);









var _dec, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





var SETTING = 'SETTING';
var SEARCH = 'SEARCH';
var PRAYER = 'PRAYER';
var NEWS = 'NEWS';

var UserService = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_decorators__["b" /* toast */])(), (_class = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(UserService, _BaseService);

  function UserService() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UserService);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserService.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(UserService)).call(this, {
      current: {
        nickname: '未登录'
      }
    }));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UserService, [{
    key: 'initialize',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(vue) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.rootPath = vue.$route.fullPath;
                console.info('launch', this.rootPath);
                _context.next = 4;
                return this.loadCurrent();

              case 4:
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getSetting();

              case 6:
                this.setting = _context.sent;

                if (!(vue.$route.name == 'movie')) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                _context.next = 11;
                return this.checkUserState(vue, false, false, true);

              case 11:
                if (!_context.sent) {
                  _context.next = 15;
                  break;
                }

                if (!(vue.$route.name == 'phone' || vue.$route.name == 'subscribe')) {
                  _context.next = 15;
                  break;
                }

                this.goReturn(vue);
                return _context.abrupt('return');

              case 15:
                if (this.settingCallback) {
                  this.settingCallback();
                  this.settingCallback = null;
                }

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize(_x) {
        return _ref.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: 'checkUserState',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(vue) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var tip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var now, last, r;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.info('check wechat', window.isWechat);

                if (window.isWechat) {
                  _context2.next = 9;
                  break;
                }

                if (!isFirst) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', true);

              case 4:
                if (!this._token) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 9;
                break;

              case 7:
                // console.info('--- go phone login')
                // this.rootPath = vue.$route.fullPath
                // vue.$router.push('/phone')
                window.location.href = 'https://www.fytvapp.com/wap/';
                return _context2.abrupt('return', false);

              case 9:
                console.info('check time', this.setting.h5_force_interval_time, force);

                if (!(this.setting.h5_force_interval_time && !force)) {
                  _context2.next = 16;
                  break;
                }

                now = Date.now();
                last = window.localStorage.getItem('last_check');

                if (!(last && (Date.now() - last) / 3600000 < this.setting.h5_force_interval_time)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt('return', true);

              case 15:
                window.localStorage.setItem('last_check', now);

              case 16:
                console.info('check force mobile');

                if (!(this.setting.h5_force_mobile && !this.current.vmobile)) {
                  _context2.next = 22;
                  break;
                }

                this.rootPath = vue.$route.fullPath;
                console.info('--', this.rootPath);
                if (tip) {
                  vue.$router.replace('/phone?tip=1');
                } else {
                  vue.$router.replace('/phone');
                }
                return _context2.abrupt('return', false);

              case 22:
                console.info('check force subscribe');

                if (!this.setting.h5_force_subscribe) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 26;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getSubscribe(this._token, this.setting.h5_force_subscribe_appid, this.current.unionid);

              case 26:
                r = _context2.sent;

                if (r) {
                  _context2.next = 32;
                  break;
                }

                this.rootPath = vue.$route.fullPath;
                console.info('--', this.rootPath);
                if (tip) {
                  vue.$router.replace('/subscribe?tip=1');
                } else {
                  vue.$router.replace('/subscribe');
                }
                return _context2.abrupt('return', false);

              case 32:
                return _context2.abrupt('return', true);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkUserState(_x2) {
        return _ref2.apply(this, arguments);
      }

      return checkUserState;
    }()
  }, {
    key: 'isSettingReady',
    value: function isSettingReady(callback) {
      if (this.setting) {
        callback();
      } else {
        this.settingCallback = callback;
      }
    }
  }, {
    key: 'goReturn',
    value: function goReturn(vue) {
      var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.rootPath.indexOf('/phone') >= 0 || this.rootPath.indexOf('/subscribe') >= 0) {
        vue.$router.replace('/');
      } else {
        vue.$router.replace(this.rootPath);
      }
    }
  }, {
    key: 'goOauth',
    value: function goOauth() {
      // let url = encodeURIComponent(`https://${window.location.host}/?token${window.location.hash}`)
      // window.location.replace(`https://users-api.sanmanuela.net/api/auth/webpage?appid=1&callback=${url}`)
    }
  }, {
    key: 'loadCurrent',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.current.userid && this._token)) {
                  _context3.next = 10;
                  break;
                }

                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getCurrent(this._token);

              case 4:
                this.data.current = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](1);
                return _context3.abrupt('return', this.goOauth());

              case 10:
                return _context3.abrupt('return', this.current);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function loadCurrent() {
        return _ref3.apply(this, arguments);
      }

      return loadCurrent;
    }()
  }, {
    key: 'getSetting',
    value: function getSetting() {
      return parseInt(__WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].load(SETTING, 0));
    }
  }, {
    key: 'setSetting',
    value: function setSetting(value) {
      __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].save(SETTING, value);
    }
  }, {
    key: 'isSubscribeOff',
    value: function isSubscribeOff() {
      return (this.getSetting() & 1) === 1;
    }
  }, {
    key: 'closeSubscribe',
    value: function closeSubscribe() {
      this.setSetting(this.getSetting() | 1);
    }
  }, {
    key: 'addFavourite',
    value: function addFavourite(movie) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.addFav(this._token, 1, movie.movid);
    }
  }, {
    key: 'getFavourites',
    value: function getFavourites() {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getFavList(this._token);
    }
  }, {
    key: 'isFavourite',
    value: function isFavourite(movid) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getFav(this._token, 1, movid);
    }
  }, {
    key: 'removeFavourite',
    value: function removeFavourite(fid) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.delFav(this._token, fid);
    }
  }, {
    key: 'addSearchHistory',
    value: function addSearchHistory(value) {
      var history = this.getSearchHistory();
      var index = history.indexOf(value);
      if (index === 0) {
        return;
      }
      if (index > 0) {
        history.splice(index, 1);
      }
      history.unshift(value);
      if (history.length > 10) {
        history.pop();
      }
      __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].save(SEARCH, history);
    }
  }, {
    key: 'getSearchHistory',
    value: function getSearchHistory() {
      return __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].load(SEARCH, []);
    }
  }, {
    key: 'addNote',
    value: function addNote(movid, urlid, title, subtitle, content) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.addNode(this._token, 1, movid, urlid, title, subtitle, content);
    }
  }, {
    key: 'updateNode',
    value: function updateNode(id, title, subtitle, content) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.updateNode(this._token, id, title, subtitle, content);
    }
  }, {
    key: 'getNote',
    value: function getNote(tid, urlid) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getNode(this._token, 1, tid, urlid);
    }
  }, {
    key: 'getNotes',
    value: function getNotes() {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getNodeList(this._token);
    }
  }, {
    key: 'removeNote',
    value: function removeNote(id) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.delNode(this._token, id);
    }
  }, {
    key: 'getPlaybacks',
    value: function getPlaybacks() {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getHistory(this._token, 1);
    }
  }, {
    key: 'removePlayback',
    value: function removePlayback(id) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.delHistory(this._token, id);
    }
  }, {
    key: 'getPrayer',
    value: function getPrayer() {
      return __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].load(PRAYER, 0);
    }
  }, {
    key: 'readPrayer',
    value: function readPrayer(time) {
      __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].save(PRAYER, time);
    }
  }, {
    key: 'getLastNews',
    value: function getLastNews() {
      return __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].load(NEWS, 0);
    }
  }, {
    key: 'readLastNews',
    value: function readLastNews(time) {
      __WEBPACK_IMPORTED_MODULE_8__util_cache__["a" /* default */].save(NEWS, time);
    }
  }, {
    key: 'getPhoneCode',
    value: function getPhoneCode(phone) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.getPhoneCode(phone);
    }
  }, {
    key: 'bindPhone',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(phone, code, itc) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.bindPhone(this._token, phone, code, itc);

              case 2:
                this.current.vmobile = 1;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function bindPhone(_x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      }

      return bindPhone;
    }()
  }, {
    key: 'loginByPhone',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(phone, code, itc) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].user.loginByPhone(1, phone, code, itc);

              case 2:
                res = _context5.sent;

                this.token = res.token;
                _context5.next = 6;
                return this.loadCurrent();

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loginByPhone(_x10, _x11, _x12) {
        return _ref5.apply(this, arguments);
      }

      return loginByPhone;
    }()
  }, {
    key: 'current',
    get: function get() {
      return this.data.current;
    }
  }, {
    key: 'token',
    set: function set(value) {
      if (!value) {
        value = window.localStorage.getItem('_utoken');
      }
      if (value) {
        this._token = value;
        window.localStorage.setItem('_utoken', value);
      } else {
        if (window.isWechat) {
          this.goOauth();
        }
      }
    }
  }]);

  return UserService;
}(__WEBPACK_IMPORTED_MODULE_11__BaseService__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadCurrent', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadCurrent'), _class.prototype)), _class));


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WechatService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BaseService__ = __webpack_require__(18);












var DEFAULT = {
  title: '推荐给你一个不错的福音APP',
  desc: 'MFUYIN.TV\n福音影视网\n扎根基督 服侍教会',
  link: 'https://' + getHost(),
  imgUrl: 'https://' + getHost() + '/static/logo.png'
};

function getHost() {
  return window.location.host;
}

var WechatService = function (_BaseService) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(WechatService, _BaseService);

  function WechatService() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, WechatService);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WechatService.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(WechatService)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(WechatService, [{
    key: 'getJsSign',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = window.location.href;
                index = url.indexOf('#');

                if (index >= 0) {
                  url = url.substr(0, index);
                }
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].other.getJsSign({
                  url: url
                });

              case 5:
                return _context.abrupt('return', _context.sent);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getJsSign() {
        return _ref.apply(this, arguments);
      }

      return getJsSign;
    }()
  }, {
    key: 'sign',
    value: function sign(params) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var result;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _this2.getJsSign();

                case 3:
                  result = _context2.sent;

                  window.wx.config({
                    debug: !!params.debug,
                    appId: result.appId,
                    timestamp: result.timestamp,
                    nonceStr: result.nonceStr,
                    signature: result.signature,
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
                  });
                  window.wx.ready(function () {
                    _this2.ready = true;
                    _this2.callShare(_this2.lastShare);
                  });
                  resolve();
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](0);

                  reject(_context2.t0);

                case 12:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[0, 9]]);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: 'callShare',
    value: function callShare(info) {
      if (this.ready) {
        info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULT, info);
        window.wx.onMenuShareTimeline(info);
        window.wx.onMenuShareAppMessage(info);
      } else {
        this.lastShare = info;
      }
    }
  }]);

  return WechatService;
}(__WEBPACK_IMPORTED_MODULE_10__BaseService__["a" /* default */]);



/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseApi__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_decorators__ = __webpack_require__(12);







var _dec, _dec2, _dec3, _dec4, _dec5, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var CategoryApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取推荐列表失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取分类列表失败'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取牧者专栏失败'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取全部分类列表失败'), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取圣经目录失败'), (_class = function (_BaseApi) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CategoryApi, _BaseApi);

  function CategoryApi() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CategoryApi);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CategoryApi.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CategoryApi)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CategoryApi, [{
    key: 'getRecommendations',
    value: function getRecommendations() {
      return this.httpJsonp('/misc/indexCategory');
    }
  }, {
    key: 'getPage',
    value: function getPage(params) {
      return this.httpJsonp('/category/index', params);
    }
  }, {
    key: 'getMZZL',
    value: function getMZZL() {
      return this.httpJsonp('/category/mzzl');
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      return this.httpJsonp('/category/all');
    }
  }, {
    key: 'getBible',
    value: function getBible() {
      return this.httpJsonp('/category/bible');
    }
  }]);

  return CategoryApi;
}(__WEBPACK_IMPORTED_MODULE_6__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getRecommendations', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getRecommendations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getPage', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getMZZL', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getMZZL'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getAll', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getAll'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getBible', [_dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getBible'), _class.prototype)), _class));


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MovieApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseApi__ = __webpack_require__(25);







var _dec, _dec2, _dec3, _dec4, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var MovieApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取影片列表失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取影片详情失败'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取视频资源失败'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取影片列表失败'), (_class = function (_BaseApi) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MovieApi, _BaseApi);

  function MovieApi() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MovieApi);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MovieApi.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(MovieApi)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MovieApi, [{
    key: 'getPage',
    value: function getPage(params) {
      return this.httpJsonp('/movie/lists', params);
    }
  }, {
    key: 'getDetail',
    value: function getDetail(params) {
      return this.httpGet('/movie/index', params);
    }
  }, {
    key: 'getResource',
    value: function getResource(params) {
      return this.httpGet('/url/index', params);
    }
  }, {
    key: 'getTops',
    value: function getTops() {
      return this.httpJsonp('/movie/tops', {});
    }
  }]);

  return MovieApi;
}(__WEBPACK_IMPORTED_MODULE_7__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getPage', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDetail', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getDetail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getResource', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getResource'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getTops', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getTops'), _class.prototype)), _class));


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseApi__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_decorators__ = __webpack_require__(12);







var _dec, _dec2, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var NewsApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取消息列表失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decorators__["a" /* exception */])('获取消息内容失败'), (_class = function (_BaseApi) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NewsApi, _BaseApi);

  function NewsApi() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NewsApi);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NewsApi.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NewsApi)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NewsApi, [{
    key: 'getPage',
    value: function getPage(params) {
      return this.httpJsonp('/announce/lists', params);
    }
  }, {
    key: 'getDetail',
    value: function getDetail(params) {
      return this.httpJsonp('/announce/index', params);
    }
  }]);

  return NewsApi;
}(__WEBPACK_IMPORTED_MODULE_6__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getPage', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getPage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDetail', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getDetail'), _class.prototype)), _class));


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OtherApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseApi__ = __webpack_require__(25);







var _dec, _dec2, _dec3, _dec4, _dec5, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var OtherApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取关于我们失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取配置失败'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取轮播图失败'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取代祷支持失败'), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('提交反馈失败'), (_class = function (_BaseApi) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OtherApi, _BaseApi);

  function OtherApi() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OtherApi);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OtherApi.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OtherApi)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OtherApi, [{
    key: 'getAbout',
    value: function getAbout(params) {
      return this.httpJsonp('/misc/about', params);
    }
  }, {
    key: 'getSetting',
    value: function getSetting(params) {
      return this.httpGet('/setting/index', params);
    }
  }, {
    key: 'getBanners',
    value: function getBanners(params) {
      return this.httpJsonp('/movie/flash', params);
    }
  }, {
    key: 'getPrayerSupport',
    value: function getPrayerSupport(params) {
      return this.httpJsonp('/prayersupport/index', params);
    }
  }, {
    key: 'feedback',
    value: function feedback(params) {
      return this.httpJsonp('/feedback/submit', params);
    }
  }, {
    key: 'getJsSign',
    value: function getJsSign(params) {
      return this.httpJsonp('//wechat.sanmanuela.com/api/weixin/tool/share.php', params);
    }
  }, {
    key: 'getPaySetting',
    value: function getPaySetting() {
      return this.httpJsonp('/misc/miniapp_pay');
    }
  }]);

  return OtherApi;
}(__WEBPACK_IMPORTED_MODULE_7__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getAbout', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getAbout'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getSetting', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getSetting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getBanners', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getBanners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getPrayerSupport', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getPrayerSupport'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'feedback', [_dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'feedback'), _class.prototype)), _class));


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BaseApi__ = __webpack_require__(25);









var _dec, _dec2, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var domain = '//users-api.sanmanuela.net/api';

var UserApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_decorators__["a" /* exception */])('获取用户信息失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_decorators__["a" /* exception */])('登录失败'), (_class = function (_BaseApi) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(UserApi, _BaseApi);

  function UserApi() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UserApi);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UserApi.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(UserApi)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UserApi, [{
    key: 'postRequest',
    value: function postRequest(response, url) {
      if (url.indexOf('/member/ping') > 0 || url.indexOf('/tools/subscribeStatus') > 0) {
        return response;
      }
      if (response.code == 0) {
        return response.data;
      }
      throw new Error('token error');
    }
  }, {
    key: 'getCurrent',
    value: function getCurrent(token) {
      return this.httpGet(domain + '/member/account', {
        token: token
      });
    }
  }, {
    key: 'heartBeat',
    value: function heartBeat(token) {
      return this.httpGet(domain + '/member/ping', {
        token: token
      });
    }
  }, {
    key: 'getFavList',
    value: function getFavList(token) {
      return this.httpGet(domain + '/favorite/index', {
        token: token
      });
    }
  }, {
    key: 'getFav',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(token, mid, tid) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.httpGet(domain + '/favorite/detail', {
                  token: token,
                  mid: mid,
                  tid: tid
                });

              case 3:
                return _context.abrupt('return', _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', null);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function getFav(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return getFav;
    }()
  }, {
    key: 'addFav',
    value: function addFav(token, mid, tid) {
      return this.httpGet(domain + '/favorite/add', {
        token: token,
        mid: mid,
        tid: tid
      });
    }
  }, {
    key: 'delFav',
    value: function delFav(token, id) {
      return this.httpGet(domain + '/favorite/delete', {
        token: token,
        id: id
      });
    }
  }, {
    key: 'getHistory',
    value: function getHistory(token, mid) {
      return this.httpGet(domain + '/history/index', {
        token: token,
        mid: mid
      });
    }
  }, {
    key: 'delHistory',
    value: function delHistory(token, id) {
      return this.httpGet(domain + '/history/delete', {
        token: token,
        id: id
      });
    }
  }, {
    key: 'getNodeList',
    value: function getNodeList(token) {
      return this.httpGet(domain + '/notepad/index', {
        token: token
      });
    }
  }, {
    key: 'getNode',
    value: function getNode(token, mid, tid, urlid) {
      return this.httpGet(domain + '/notepad/detail', {
        token: token,
        mid: mid,
        tid: tid,
        urlid: urlid
      });
    }
  }, {
    key: 'addNode',
    value: function addNode(token, mid, tid, urlid, title, subtitle, content) {
      return this.httpPost(domain + '/notepad/add', {
        token: token,
        mid: mid,
        tid: tid,
        urlid: urlid,
        title: title,
        subtitle: subtitle,
        content: content
      });
    }
  }, {
    key: 'updateNode',
    value: function updateNode(token, id, title, subtitle, content) {
      return this.httpPost(domain + '/notepad/edit', {
        token: token,
        id: id,
        title: title,
        subtitle: subtitle,
        content: content
      });
    }
  }, {
    key: 'delNode',
    value: function delNode(token, id) {
      return this.httpGet(domain + '/notepad/delete', {
        token: token,
        id: id
      });
    }
  }, {
    key: 'getSubscribe',
    value: function getSubscribe(token, type, unionid) {
      return this.httpGet(domain + '/tools/subscribeStatus', {
        token: token,
        type: type,
        unionid: unionid
      });
    }
  }, {
    key: 'getSetting',
    value: function getSetting() {
      return this.httpGet(domain + '/setting');
    }
  }, {
    key: 'getPhoneCode',
    value: function getPhoneCode(mobile) {
      return this.httpGet(domain + '/tools/sendSmsCode', {
        mobile: mobile
      });
    }
  }, {
    key: 'bindPhone',
    value: function bindPhone(token, mobile, vcode, itc) {
      return this.httpGet(domain + '/member/bindMobile', {
        token: token,
        mobile: mobile,
        vcode: vcode,
        itc: itc
      });
    }
  }, {
    key: 'loginByPhone',
    value: function loginByPhone(appid, mobile, vcode, itc) {
      return this.httpGet(domain + '/auth/login_mobile', {
        appid: appid,
        mobile: mobile,
        vcode: vcode,
        itc: itc
      });
    }
  }]);

  return UserApi;
}(__WEBPACK_IMPORTED_MODULE_9__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getCurrent', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getCurrent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loginByPhone', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loginByPhone'), _class.prototype)), _class));


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_decorators__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseApi__ = __webpack_require__(25);







var _dec, _dec2, _dec3, _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}



var domain = 'https://service.sanmanuela.net';

var NewsApi = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取直播列表失败'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('获取直播详情失败'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_decorators__["a" /* exception */])('点赞失败'), (_class = function (_BaseApi) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NewsApi, _BaseApi);

    function NewsApi() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NewsApi);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NewsApi.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NewsApi)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NewsApi, [{
        key: 'postRequest',
        value: function postRequest(response, url) {
            if (response.code == 1) {
                return response.data;
            }
            throw new Error(response.msg);
        }
    }, {
        key: 'getLiveRooms',
        value: function getLiveRooms(page, limit) {
            return this.httpGet(domain + '/api/live.room/index', { page: page, limit: limit });
        }
    }, {
        key: 'getLiveDetail',
        value: function getLiveDetail(id) {
            return this.httpGet(domain + '/api/live.room/detail', { id: id });
        }
    }, {
        key: 'postVote',
        value: function postVote(id) {
            return this.httpGet(domain + '/api/live.room/vote', { id: id });
        }
    }, {
        key: 'postHit',
        value: function postHit(ac, id) {
            return this.httpPost(domain + '/api/common.report/hit', { ac: ac, id: id });
        }
    }]);

    return NewsApi;
}(__WEBPACK_IMPORTED_MODULE_7__BaseApi__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'getLiveRooms', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getLiveRooms'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getLiveDetail', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'getLiveDetail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'postVote', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'postVote'), _class.prototype)), _class));


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuntimeException; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);





var RuntimeException = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(RuntimeException, _Error);

  function RuntimeException(message, cause) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RuntimeException);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RuntimeException.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RuntimeException)).call(this, message));

    _this.cause = cause;
    return _this;
  }

  return RuntimeException;
}(Error);



/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createAliPlayer;
/* harmony export (immutable) */ __webpack_exports__["a"] = dispostAliPlayer;
function createAliPlayer(domId, source, callback) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { auto: true, poster: '', isLive: false, rate: false };

    return new Aliplayer({
        id: domId,
        source: source,
        width: "100%",
        height: "100%",
        autoplay: options.auto,
        cover: options.poster,
        isLive: options.isLive,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
        skinLayout: [{
            "name": "bigPlayButton",
            "align": "cc"
        }, {
            "name": "H5Loading",
            "align": "cc"
        }, {
            "name": "errorDisplay",
            "align": "tlabs",
            "x": 0,
            "y": 0
        }, {
            "name": "tooltip",
            "align": "blabs",
            "x": 0,
            "y": 56
        }, {
            "name": "controlBar",
            "align": "blabs",
            "x": 0,
            "y": 0,
            "children": [{
                "name": "progress",
                "align": "blabs",
                "x": 0,
                "y": 44
            }, {
                "name": "playButton",
                "align": "tl",
                "x": 15,
                "y": 12
            }, {
                "name": "timeDisplay",
                "align": "tl",
                "x": 10,
                "y": 7
            }, {
                "name": "fullScreenButton",
                "align": "tr",
                "x": 10,
                "y": 12
            }, {
                "name": "volume",
                "align": "tr",
                "x": 5,
                "y": 10
            }]
        }],
        components: options.rate ? [{
            name: 'RateComponent',
            type: AliPlayerComponent.RateComponent
        }] : []
    }, function (player) {
        console.log("The player is created");
        if (callback) {
            callback();
        }
    });
}

function dispostAliPlayer(domId, player) {
    if (player && player.dispose) {
        player.dispose();
    }
    var dom = document.getElementById(domId);
    if (dom) {
        dom.innerHTML = '';
    }
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  load: function load(name, defValue) {
    var value = window.localStorage.getItem(name);
    if (value) {
      return JSON.parse(value);
    } else {
      return defValue;
    }
  },
  save: function save(name, value) {
    window.localStorage.setItem(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__about__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bible__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bookshelf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bookshelf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bookshelf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bookshelf_latest_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bookshelf_latest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bookshelf_latest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__category__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__category_all_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__category_all_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__category_all_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_priest_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category_priest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__category_priest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__favourite__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__favourite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__favourite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lives_index_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lives_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__lives_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lives_Room_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lives_Room_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__lives_Room_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__more__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__movie__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__movie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__movie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__news__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__news___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__news__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__news_Detail_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__news_Detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__news_Detail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__note__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__note_editor_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__note_editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__note_editor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pay__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__phone_index_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__phone_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__phone_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__playback__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__playback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__playback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__prayer__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__prayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__prayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__search__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__subscribe_root_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__subscribe_root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__subscribe_root_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__suggest__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__suggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__suggest__);

























var root = [{
  name: 'home',
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_8__home___default.a
}, {
  name: 'category',
  path: '/category',
  component: __WEBPACK_IMPORTED_MODULE_4__category___default.a,
  meta: {
    title: '分类'
  }
}, {
  name: 'lives',
  path: '/lives',
  component: __WEBPACK_IMPORTED_MODULE_9__lives_index_vue___default.a,
  meta: {
    title: '一起看'
  }
}, {
  name: 'live-room',
  path: '/lives/:id',
  component: __WEBPACK_IMPORTED_MODULE_10__lives_Room_vue___default.a,
  meta: {
    title: ''
  }
}, {
  name: 'more',
  path: '/more',
  component: __WEBPACK_IMPORTED_MODULE_11__more___default.a,
  meta: {
    title: '更多'
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ([].concat(root, [{
  name: 'bookshelf',
  path: '/bookshelf/:catid?',
  component: __WEBPACK_IMPORTED_MODULE_2__bookshelf___default.a
}, {
  name: 'latest',
  path: '/latest',
  component: __WEBPACK_IMPORTED_MODULE_3__bookshelf_latest_vue___default.a
}, {
  name: 'movie',
  path: '/movie/:movid',
  component: __WEBPACK_IMPORTED_MODULE_12__movie___default.a,
  meta: {
    keepAlive: true
  }
}, {
  name: 'category-all',
  path: '/category/all',
  component: __WEBPACK_IMPORTED_MODULE_5__category_all_vue___default.a,
  meta: {
    title: '全部分类'
  }
}, {
  name: 'category-priest',
  path: '/category/priest',
  component: __WEBPACK_IMPORTED_MODULE_6__category_priest_vue___default.a,
  meta: {
    title: '牧者专栏'
  }
}, {
  name: 'search',
  path: '/search',
  component: __WEBPACK_IMPORTED_MODULE_21__search___default.a,
  meta: {
    title: '搜索'
  }
}, {
  name: 'news',
  path: '/news',
  component: __WEBPACK_IMPORTED_MODULE_13__news___default.a,
  meta: {
    title: '站内公告'
  }
}, {
  name: 'news-detail',
  path: '/news/:id',
  component: __WEBPACK_IMPORTED_MODULE_14__news_Detail_vue___default.a
}, {
  name: 'suggest',
  path: '/suggest',
  component: __WEBPACK_IMPORTED_MODULE_23__suggest___default.a,
  meta: {
    title: '留言反馈'
  }
}, {
  name: 'prayer',
  path: '/prayer',
  component: __WEBPACK_IMPORTED_MODULE_20__prayer___default.a,
  meta: {
    title: '代祷支持'
  }
}, {
  name: 'about',
  path: '/about',
  component: __WEBPACK_IMPORTED_MODULE_0__about___default.a,
  meta: {
    title: '关于我们'
  }
}, {
  name: 'favourite',
  path: '/favourite',
  component: __WEBPACK_IMPORTED_MODULE_7__favourite___default.a,
  meta: {
    title: '我的收藏'
  }
}, {
  name: 'playback',
  path: '/playback',
  component: __WEBPACK_IMPORTED_MODULE_19__playback___default.a,
  meta: {
    title: '播放记录'
  }
}, {
  name: 'note',
  path: '/note',
  component: __WEBPACK_IMPORTED_MODULE_15__note___default.a,
  meta: {
    title: '我的笔记'
  }
}, {
  name: 'note-editor',
  path: '/note/:movid/:urlid',
  component: __WEBPACK_IMPORTED_MODULE_16__note_editor_vue___default.a,
  meta: {
    title: '编辑笔记'
  }
}, {
  name: 'pay',
  path: '/pay',
  component: __WEBPACK_IMPORTED_MODULE_17__pay___default.a,
  mate: {
    title: '奉献支持'
  }
}, {
  name: 'bible',
  path: '/bible',
  component: __WEBPACK_IMPORTED_MODULE_1__bible___default.a,
  mate: {
    title: '视频查经'
  }
}, {
  name: 'subscribe',
  path: '/subscribe',
  component: __WEBPACK_IMPORTED_MODULE_22__subscribe_root_vue___default.a,
  meta: {
    title: '关注公众号'
  }
}, {
  name: 'phone',
  path: '/phone',
  component: __WEBPACK_IMPORTED_MODULE_18__phone_index_vue___default.a,
  meta: {
    title: '绑定手机号'
  }
}]));

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  A: [{
    n: "阿富汗",
    c: "93"
  }, {
    n: "阿尔巴尼亚",
    c: "355"
  }, {
    n: "阿尔及利亚",
    c: "213"
  }, {
    n: "安道尔",
    c: "376"
  }, {
    n: "安哥拉",
    c: "244"
  }, {
    n: "安圭拉",
    c: "1264"
  }, {
    n: "安提瓜和巴布达",
    c: "1268"
  }, {
    n: "阿根廷",
    c: "54"
  }, {
    n: "阿鲁巴",
    c: "297"
  }, {
    n: "澳大利亚",
    c: "61"
  }, {
    n: "奥地利",
    c: "43"
  }, {
    n: "阿塞拜疆",
    c: "994"
  }, {
    n: "埃及",
    c: "20"
  }, {
    n: "爱沙尼亚",
    c: "372"
  }, {
    n: "埃塞俄比亚",
    c: "251"
  }, {
    n: "爱尔兰",
    c: "353"
  }, {
    n: "阿曼",
    c: "968"
  }, {
    n: "阿拉伯联合酋长国",
    c: "971"
  }],
  B: [{
    n: "巴哈马",
    c: "1242"
  }, {
    n: "巴林",
    c: "973"
  }, {
    n: "巴巴多斯",
    c: "1246"
  }, {
    n: "白俄罗斯",
    c: "375"
  }, {
    n: "比利时",
    c: "32"
  }, {
    n: "伯利兹",
    c: "501"
  }, {
    n: "贝宁",
    c: "229"
  }, {
    n: "百慕大",
    c: "1441"
  }, {
    n: "不丹",
    c: "975"
  }, {
    n: "玻利维亚",
    c: "591"
  }, {
    n: "波斯尼亚和黑塞哥维那",
    c: "387"
  }, {
    n: "博茨瓦纳",
    c: "267"
  }, {
    n: "巴西",
    c: "55"
  }, {
    n: "保加利亚",
    c: "359"
  }, {
    n: "布基纳法索",
    c: "226"
  }, {
    n: "布隆迪",
    c: "257"
  }, {
    n: "冰岛",
    c: "354"
  }, {
    n: "巴基斯坦",
    c: "92"
  }, {
    n: "巴拿马",
    c: "507"
  }, {
    n: "巴布亚新几内亚",
    c: "675"
  }, {
    n: "巴拉圭",
    c: "595"
  }, {
    n: "波兰",
    c: "48"
  }, {
    n: "波多黎各",
    c: "1787"
  }],
  C: [{
    n: "赤道几内亚",
    c: "240"
  }],
  D: [{
    n: "丹麦",
    c: "45"
  }, {
    n: "多米尼克",
    c: "1767"
  }, {
    n: "多米尼加共和国",
    c: "1809"
  }, {
    n: "德国",
    c: "49"
  }, {
    n: "东帝汶",
    c: "670"
  }, {
    n: "多哥",
    c: "228"
  }],
  E: [{
    n: "厄瓜多尔",
    c: "593"
  }, {
    n: "厄立特里亚",
    c: "291"
  }, {
    n: "俄罗斯",
    c: "7"
  }],
  F: [{
    n: "法属圭亚那",
    c: "594"
  }, {
    n: "法属圣马丁",
    c: "590"
  }, {
    n: "佛得角",
    c: "238"
  }, {
    n: "法罗群岛",
    c: "298"
  }, {
    n: "斐济",
    c: "679"
  }, {
    n: "芬兰",
    c: "358"
  }, {
    n: "法国",
    c: "33"
  }, {
    n: "法属波利尼西亚",
    c: "689"
  }, {
    n: "菲律宾",
    c: "63"
  }],
  G: [{
    n: "瓜德罗普岛",
    c: "590"
  }, {
    n: "根西岛",
    c: "44"
  }, {
    n: "哥伦比亚",
    c: "57"
  }, {
    n: "哥斯达黎加",
    c: "506"
  }, {
    n: "古巴",
    c: "53"
  }, {
    n: "刚果（金）",
    c: "243"
  }, {
    n: "冈比亚",
    c: "220"
  }, {
    n: "格鲁吉亚",
    c: "995"
  }, {
    n: "格陵兰",
    c: "299"
  }, {
    n: "格林纳达",
    c: "1473"
  }, {
    n: "关岛",
    c: "1671"
  }, {
    n: "圭亚那",
    c: "592"
  }, {
    n: "刚果（布）",
    c: "242"
  }],
  H: [{
    n: "海地",
    c: "509"
  }, {
    n: "洪都拉斯",
    c: "504"
  }, {
    n: "哈萨克斯坦",
    c: "7"
  }, {
    n: "黑山共和国",
    c: "382"
  }, {
    n: "荷兰",
    c: "31"
  }, {
    n: "荷属安的列斯群岛",
    c: "599"
  }, {
    n: "韩国",
    c: "82"
  }],
  J: [{
    n: "加勒比荷兰",
    c: "599"
  }, {
    n: "柬埔寨",
    c: "855"
  }, {
    n: "加拿大",
    c: "1"
  }, {
    n: "捷克共和国",
    c: "420"
  }, {
    n: "吉布提",
    c: "253"
  }, {
    n: "加蓬",
    c: "241"
  }, {
    n: "加纳",
    c: "233"
  }, {
    n: "津巴布韦",
    c: "263"
  }, {
    n: "几内亚",
    c: "224"
  }, {
    n: "几内亚比绍",
    c: "245"
  }, {
    n: "基里巴斯",
    c: "686"
  }, {
    n: "吉尔吉斯斯坦",
    c: "996"
  }],
  K: [{
    n: "喀麦隆",
    c: "237"
  }, {
    n: "开曼群岛",
    c: "1345"
  }, {
    n: "科科斯群岛",
    c: "61"
  }, {
    n: "科摩罗",
    c: "269"
  }, {
    n: "库克群岛",
    c: "682"
  }, {
    n: "克罗地亚",
    c: "385"
  }, {
    n: "科特迪瓦",
    c: "225"
  }, {
    n: "肯尼亚",
    c: "254"
  }, {
    n: "科威特",
    c: "965"
  }, {
    n: "卡塔尔",
    c: "974"
  }],
  L: [{
    n: "老挝人民民主共和国",
    c: "856"
  }, {
    n: "拉脱维亚",
    c: "371"
  }, {
    n: "黎巴嫩",
    c: "961"
  }, {
    n: "莱索托",
    c: "266"
  }, {
    n: "利比里亚",
    c: "231"
  }, {
    n: "利比亚",
    c: "218"
  }, {
    n: "列支敦士登",
    c: "423"
  }, {
    n: "立陶宛",
    c: "370"
  }, {
    n: "卢森堡",
    c: "352"
  }, {
    n: "罗马尼亚",
    c: "40"
  }, {
    n: "卢旺达",
    c: "250"
  }],
  M: [{
    n: "马提尼克",
    c: "596"
  }, {
    n: "美属萨摩亚",
    c: "1684"
  }, {
    n: "孟加拉国",
    c: "880"
  }, {
    n: "缅甸",
    c: "95"
  }, {
    n: "曼岛",
    c: "44"
  }, {
    n: "马其顿",
    c: "389"
  }, {
    n: "马达加斯加",
    c: "261"
  }, {
    n: "马拉维",
    c: "265"
  }, {
    n: "马来西亚",
    c: "60"
  }, {
    n: "马尔代夫",
    c: "960"
  }, {
    n: "马里",
    c: "223"
  }, {
    n: "马耳他",
    c: "356"
  }, {
    n: "毛里塔尼亚",
    c: "222"
  }, {
    n: "毛里求斯",
    c: "230"
  }, {
    n: "马约特",
    c: "262"
  }, {
    n: "墨西哥",
    c: "52"
  }, {
    n: "摩尔多瓦",
    c: "373"
  }, {
    n: "摩纳哥",
    c: "377"
  }, {
    n: "蒙古",
    c: "976"
  }, {
    n: "蒙塞拉特群岛",
    c: "1664"
  }, {
    n: "摩洛哥",
    c: "212"
  }, {
    n: "莫桑比克",
    c: "258"
  }, {
    n: "秘鲁",
    c: "51"
  }, {
    n: "美国",
    c: "1"
  }, {
    n: "美属维京群岛",
    c: "1340"
  }],
  N: [{
    n: "纳米比亚",
    c: "264"
  }, {
    n: "尼泊尔",
    c: "977"
  }, {
    n: "尼加拉瓜",
    c: "505"
  }, {
    n: "尼日尔",
    c: "227"
  }, {
    n: "尼日利亚",
    c: "234"
  }, {
    n: "挪威",
    c: "47"
  }, {
    n: "南非",
    c: "27"
  }],
  P: [{
    n: "帕劳",
    c: "680"
  }, {
    n: "葡萄牙",
    c: "351"
  }],
  R: [{
    n: "日本",
    c: "81"
  }, {
    n: "瑞典",
    c: "46"
  }, {
    n: "瑞士",
    c: "41"
  }],
  S: [{
    n: "斯瓦尔巴和扬马延",
    c: "47"
  }, {
    n: "圣诞岛",
    c: "61"
  }, {
    n: "塞浦路斯",
    c: "357"
  }, {
    n: "萨尔瓦多",
    c: "503"
  }, {
    n: "圣巴泰勒米",
    c: "590"
  }, {
    n: "圣基茨和尼维斯",
    c: "1869"
  }, {
    n: "圣卢西亚",
    c: "1758"
  }, {
    n: "圣马丁",
    c: "1721"
  }, {
    n: "圣皮埃尔和密克隆",
    c: "508"
  }, {
    n: "圣文森特和格林纳丁斯",
    c: "1784"
  }, {
    n: "萨摩亚",
    c: "685"
  }, {
    n: "圣马力诺",
    c: "378"
  }, {
    n: "圣多美和普林西比",
    c: "239"
  }, {
    n: "沙特阿拉伯",
    c: "966"
  }, {
    n: "塞内加尔",
    c: "221"
  }, {
    n: "塞尔维亚",
    c: "381"
  }, {
    n: "塞舌尔群岛",
    c: "248"
  }, {
    n: "塞拉利昂",
    c: "232"
  }, {
    n: "斯洛伐克",
    c: "421"
  }, {
    n: "斯洛文尼亚",
    c: "386"
  }, {
    n: "所罗门群岛",
    c: "677"
  }, {
    n: "索马里",
    c: "252"
  }, {
    n: "斯里兰卡",
    c: "94"
  }, {
    n: "苏丹",
    c: "249"
  }, {
    n: "斯威士兰",
    c: "268"
  }],
  T: [{
    n: "塔吉克斯坦",
    c: "992"
  }, {
    n: "坦桑尼亚",
    c: "255"
  }, {
    n: "泰国",
    c: "66"
  }, {
    n: "汤加",
    c: "676"
  }, {
    n: "特立尼达和多巴哥",
    c: "1868"
  }, {
    n: "突尼斯",
    c: "216"
  }, {
    n: "土耳其",
    c: "90"
  }, {
    n: "土库曼斯坦",
    c: "993"
  }, {
    n: "特克斯和凯科斯群岛",
    c: "1649"
  }],
  W: [{
    n: "文莱",
    c: "673"
  }, {
    n: "危地马拉",
    c: "502"
  }, {
    n: "乌干达",
    c: "256"
  }, {
    n: "乌克兰",
    c: "380"
  }, {
    n: "乌拉圭",
    c: "598"
  }, {
    n: "乌兹别克斯坦",
    c: "998"
  }, {
    n: "瓦努阿图",
    c: "678"
  }, {
    n: "委内瑞拉",
    c: "58"
  }],
  X: [{
    n: "西撒哈拉",
    c: "212"
  }, {
    n: "希腊",
    c: "30"
  }, {
    n: "匈牙利",
    c: "36"
  }, {
    n: "新喀里多尼亚",
    c: "687"
  }, {
    n: "新西兰",
    c: "64"
  }, {
    n: "新加坡",
    c: "65"
  }, {
    n: "西班牙",
    c: "34"
  }, {
    n: "叙利亚",
    c: "963"
  }],
  Y: [{
    n: "亚美尼亚",
    c: "374"
  }, {
    n: "英属维京群岛",
    c: "1284"
  }, {
    n: "印度",
    c: "91"
  }, {
    n: "印度尼西亚",
    c: "62"
  }, {
    n: "伊朗",
    c: "98"
  }, {
    n: "伊拉克",
    c: "964"
  }, {
    n: "以色列",
    c: "972"
  }, {
    n: "意大利",
    c: "39"
  }, {
    n: "牙买加",
    c: "1876"
  }, {
    n: "约旦",
    c: "962"
  }, {
    n: "英国",
    c: "44"
  }, {
    n: "越南",
    c: "84"
  }, {
    n: "也门",
    c: "967"
  }],
  Z: [{
    n: "泽西岛",
    c: "44"
  }, {
    n: "中非共和国",
    c: "236"
  }, {
    n: "乍得",
    c: "235"
  }, {
    n: "智利",
    c: "56"
  }, {
    n: "中国",
    c: "86"
  }, {
    n: "中国香港",
    c: "852"
  }, {
    n: "中国澳门",
    c: "853"
  }, {
    n: "中国台湾",
    c: "886"
  }, {
    n: "直布罗陀",
    c: "350"
  }, {
    n: "赞比亚",
    c: "260"
  }]
});

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a09294a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e9abac2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21feeba2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8090910c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(312),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29b8fdd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e5b6e74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(320),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-432201bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(315),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33dbf14a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7de8066",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b134937c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(342),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d81c80f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(306),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09b183f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73189ff2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e19dd3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(327),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56766f14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78520c32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(318),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f34c6c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(319),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-420fa455",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53a424dd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(309),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f79440f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(333),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f901e56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5cc17f72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d3ad184",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(332),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6905cf90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(314),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f5daedb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(330),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5dd5ce96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(321),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44e5393a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4eb19914",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(331),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62c75ffc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3233cba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(326),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54f8e8a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(345),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7a567a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(305),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-017913cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(325),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53f4fdd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(310),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20de6c30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "t1"
  }, [_vm._v("关注微信公众号")]), _vm._v(" "), _c('div', {
    staticClass: "t2"
  }, [_vm._v("更多生命灵粮与您共享")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "t0"
  }, [_vm._v("当前集数已播放完毕，邀请您关注公众号")]) : _c('div', {
    staticClass: "t01"
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrcode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t3"
  }, [_vm._v("关注指南:")]), _vm._v(" "), _c('div', {
    staticClass: "t4"
  }, [_vm._v("长按识别关注后，请重新进入")]), _vm._v(" "), (_vm.ignore) ? _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    staticClass: "off",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("下次再说")])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t5"
  }, [_vm._v("\n    邀请弟兄姊妹关注微信公众号，每日丰富灵粮\n    "), _c('br'), _vm._v("精彩呈现，维护通知同步获取。\n  ")])
}]}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "more": "simple"
      },
      on: {
        "longTap": _vm.onLongTap
      }
    })
  }), 1), _vm._v(" "), (_vm.list.length === 0) ? _c('div', {
    staticClass: "none"
  }, [_vm._v("暂时没有收藏内容")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提示：长按可进行删除操作")]), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "html-content",
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view",
    class: {
      'app-view': !_vm.custom
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("Copyright© 2022 福音影视网.Madrid, Spain")])])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [(_vm.audio) ? _c('div', {
    staticClass: "audioInfo"
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.playing) ? _c('div', [_vm._v("点击开始播放")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.audio) ? _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.src
    },
    on: {
      "play": _vm.onPlay,
      "pause": _vm.onPause,
      "ended": _vm.onEnd,
      "timeupdate": _vm.onTimeUpdate,
      "waiting": _vm.onWaiting,
      "loadedmetadata": _vm.onloadedmetadata
    }
  }) : _c('video', {
    ref: "video",
    attrs: {
      "src": _vm.src,
      "poster": "static/poster-1.gif",
      "x5-playsinline": "",
      "x-webkit-airplay": "",
      "webkit-playsinline": "",
      "playsinline": ""
    },
    on: {
      "play": _vm.onPlay,
      "pause": _vm.onPause,
      "ended": _vm.onEnd,
      "timeupdate": _vm.onTimeUpdate,
      "waiting": _vm.onWaiting,
      "loadedmetadata": _vm.onloadedmetadata
    }
  }), _vm._v(" "), (!_vm.playing || _vm.waiting) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toPlay
    }
  }, [(_vm.waiting) ? _c('mt-spinner') : _c('i', {
    staticClass: "music icon icon-play-o",
    attrs: {
      "href": "javascript:;"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.first) ? _c('div', {
    staticClass: "control"
  }, [(_vm.playing) ? _c('a', {
    staticClass: "icon icon-pause",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toPause
    }
  }) : _c('a', {
    staticClass: "icon icon-play1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toPlay
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("secondTime")(_vm.currentTime)))]), _vm._v(" "), _c('a', {
    ref: "track",
    staticClass: "track",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('a', {
    staticClass: "thumb",
    style: (_vm.style),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('span')])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("secondTime")(_vm.duration)))]), _vm._v(" "), (!_vm.audio) ? _c('a', {
    staticClass: "icon icon-fullscreen",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toFullScreen
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.debug) ? _c('div', {
    staticClass: "debug"
  }, [_vm._v(_vm._s(_vm.fps))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.disable && _vm.visible) ? _c('div', {
    staticClass: "container",
    style: ({
      backgroundImage: 'url(static/bg.jpg)'
    })
  }, [_c('img', {
    staticClass: "logo1",
    attrs: {
      "src": "static/logoAC.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("福音TV")]), _vm._v(" "), _c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "static/logo-icon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.fytvapp.com/mobile/"
    }
  }, [_vm._v("点此下载 福音TV App观看")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("继续网页观看")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNextPage,
      "clear": _vm.clear
    }
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.bookshelf), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item
      }
    })
  }), 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.all), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'bookshelf',
          params: {
            catid: item.id
          },
          query: {
            name: item.category
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.category) + "\n    ")])
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "nav"
  }, [_c('div', _vm._l((_vm.bible), function(item, i) {
    return _c('a', {
      key: i,
      class: {
        on: _vm.selected === i
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSelected(i)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), (_vm.selected === 2) ? _c('div', {
    staticClass: "details"
  }, _vm._l((_vm.contents), function(d, i) {
    return _c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onGo(d)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(d.name))])])
  }), 0) : [_vm._l((_vm.contents), function(item, index) {
    return [_c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, _vm._l((item.child), function(d, i) {
      return _c('a', {
        key: i,
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.onGo(d)
          }
        }
      }, [_c('div', [_vm._v(_vm._s(d.letter))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(d.name))])])
    }), 0)]
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNextPage,
      "clear": _vm.clear
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "item",
      attrs: {
        "to": {
          name: 'news-detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(item.addtime))), _c('i', {
      staticClass: "icon icon-right"
    })])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "tab fixedTop"
  }, _vm._l((_vm.types), function(item, index) {
    return _c('a', {
      class: {
        on: _vm.type === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSwitch(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appFoot"
  }, [_c('router-link', {
    class: {
      on: _vm.currentRoute === 'home'
    },
    attrs: {
      "replace": "",
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "icon icon-home"
  }), _vm._v(" "), _c('span', [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    class: {
      on: _vm.currentRoute === 'category'
    },
    attrs: {
      "replace": "",
      "to": "/category"
    }
  }, [_c('i', {
    staticClass: "icon icon-apps"
  }), _vm._v(" "), _c('span', [_vm._v("搜索")])]), _vm._v(" "), _c('router-link', {
    class: {
      on: _vm.currentRoute === 'more'
    },
    attrs: {
      "replace": "",
      "to": "/more"
    }
  }, [_c('i', {
    staticClass: "icon icon-more"
  }), _vm._v(" "), _c('span', [_vm._v("我的")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadmore', {
    ref: "loadMore",
    attrs: {
      "autoFill": false,
      "topMethod": _vm.reload,
      "bottomMethod": _vm.loadMore
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view",
    style: ({
      paddingTop: _vm.height169 + 84 + 'px'
    })
  }, [_c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "fixedTop"
  }, [(_vm.share) ? _c('div', {
    staticClass: "video",
    style: ({
      height: _vm.height169 + 'px'
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "tip",
    style: ({
      height: _vm.height169 + 'px',
      textAlign: 'center'
    })
  }, [_vm._v("\n                该视频由福音影视网提供播放\n                "), _c('br'), _vm._v("WWW.FUYINTV.COM\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready && !_vm.share),
      expression: "ready && !share"
    }],
    staticClass: "video-container",
    style: ({
      height: _vm.height169 + 'px'
    })
  }, [_c('movie-video', {
    ref: "video",
    attrs: {
      "movie": _vm.movie
    },
    on: {
      "end": _vm.onPlayEnd
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download",
    class: {
      off: !_vm.download
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.fytvapp.com"
    }
  }, [_c('i', {
    staticClass: "icon icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("点击下载福音TV APP功能更强大")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-download"
  })]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCloseDownload
    }
  })]), _vm._v(" "), _c('toolbar', {
    attrs: {
      "favourite": _vm.favourite
    },
    on: {
      "download": _vm.onOpenDownload,
      "intro": _vm.onIntro,
      "list": _vm.onList,
      "favourite": _vm.onFavourite,
      "note": _vm.onNote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "current"
  }, [_vm._v("当前播放：" + _vm._s(_vm.current.title))])], 1), _vm._v(" "), (
    _vm.movie.zs &&
    _vm.movie.zs.open &&
    _vm.movie.zs.target !== 'miniprogram'
  ) ? _c('a', {
    staticClass: "ad",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onGoAd
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.movie.zs.image
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.movie.content)
    }
  })]) : _c('play-list', {
    attrs: {
      "player": _vm.player
    },
    on: {
      "video": _vm.onClickPlayVideo,
      "audio": _vm.onPlayAudio,
      "download-audio": _vm.onDownloadAudio,
      "pdf": _vm.onDownloadPdf
    }
  }), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      paddingTop: _vm.height169 + 50 + 'px'
    })
  }, [_c('app-view', {
    attrs: {
      "custom": true
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "fixedTop"
  }, [_c('div', {
    staticClass: "player",
    style: (_vm._f("bg")(_vm.item.thumb))
  }, [_c('img', {
    attrs: {
      "src": "static/169.png"
    }
  }), _vm._v(" "), (_vm.item.push_status == 1 || _vm.item.push_status == 3) ? _c('div', [_c('div', {
    staticClass: "video",
    attrs: {
      "id": "video"
    }
  }, [_c('video', {
    attrs: {
      "poster": _vm.videoPoster,
      "src": _vm.videoUrl,
      "x5-playsinline": "",
      "x-webkit-airplay": "",
      "webkit-playsinline": "",
      "playsinline": "",
      "controls": "",
      "controlslist": "nodownload noremoteplayback noplaybackrate",
      "disablePictureInPicture": true
    }
  })])]) : _c('div', {
    staticClass: "mask"
  }, [(_vm.item.push_status == 0) ? _c('div', [_c('div', [_vm._v("直播将于" + _vm._s(_vm._f("datetime")(_vm.item.starttime)) + "开始")]), _vm._v(" "), (_vm.leftTime >= 0) ? _c('div', [_vm._v(_vm._s(_vm._f("seconds")(_vm.leftTime)))]) : _vm._e()]) : (_vm.item.push_status == 2) ? _c('div', [_vm._v("直播已结束")]) : (_vm.item.push_status == 4) ? _c('div', [_vm._v("\n                        直播已结束\n                        "), _c('br'), _vm._v("您可以\n                        "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onPlayerVideo(_vm.movid, _vm.urlid)
      }
    }
  }, [_vm._v("点击这里观看回放")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', [_c('i', {
    staticClass: "icon icon-zongrenshu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.onlineCount)))])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "icon icon-guankancishu"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.item.hits)))])]), _vm._v(" "), _c('label'), _vm._v(" "), _c('a', {
    class: {
      on: _vm.item.good
    },
    on: {
      "click": function($event) {
        return _vm.onVote(_vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-a-lujing133"
  }), _vm._v(" "), (_vm.item.good) ? _c('span', [_vm._v(_vm._s(_vm._f("unit")(_vm.item.agree)))]) : _c('span', [_vm._v("点赞")])]), _vm._v(" "), (_vm.item.donate_url) ? _c('a', {
    on: {
      "click": _vm.onShowSupport
    }
  }, [_c('i', {
    staticClass: "icon icon-a-Iconawesome-donate"
  }), _vm._v("参与\n                ")]) : _vm._e(), _vm._v(" "), (_vm.shareVisible) ? _c('a', {
    on: {
      "click": _vm.onShowShare
    }
  }, [_c('i', {
    staticClass: "icon icon-share"
  }), _vm._v("分享\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), (_vm.item.item_status == 0) ? _c('div', {
    staticClass: "html"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })]) : _c('div', {
    ref: "scroller",
    staticClass: "list"
  }, _vm._l((_vm.item.item_json), function(item, i) {
    return _c('div', {
      staticClass: "item",
      class: {
        on: i == _vm.timeIndex
      }
    }, [_c('span', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('span', {
      staticClass: "line1"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (i == _vm.timeIndex) ? _c('i', {
      staticClass: "icon icon-play1"
    }) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.item.ad && _vm.adVisible) ? _c('div', {
    staticClass: "ad"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.onOpenUrl(_vm.item.ad.linkurl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.ad.image
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.onAdClosed
    }
  }, [_vm._v("关闭")])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore
    }
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "item"
    }, [_c('router-link', {
      staticClass: "poster",
      style: (_vm._f("bg")(item.thumb)),
      attrs: {
        "to": '/lives/' + item.id
      }
    }, [_c('div', {
      staticClass: "mask"
    }, [(item.push_status == 0) ? _c('div', {
      staticClass: "live orange"
    }, [_vm._v("待直播")]) : _vm._e(), _vm._v(" "), (item.push_status == 1) ? _c('div', {
      staticClass: "live red"
    }, [_vm._v("直播中")]) : _vm._e(), _vm._v(" "), (item.push_status == 2) ? _c('div', {
      staticClass: "live gray"
    }, [_vm._v("已结束")]) : _vm._e(), _vm._v(" "), (item.push_status == 3) ? _c('div', {
      staticClass: "live blue"
    }, [_vm._v("回放")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("开播：" + _vm._s(_vm._f("datetime2")(item.starttime)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', [_c('i', {
      staticClass: "icon icon-zongrenshu"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.online)))])]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon icon-guankancishu"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.hits)))])]), _vm._v(" "), _c('span', {
      staticClass: "space"
    }), _vm._v(" "), _c('a', {
      class: {
        on: item.good
      },
      on: {
        "click": function($event) {
          return _vm.onVote(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-a-lujing133"
    }), _vm._v(" "), (item.good) ? _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.agree)))]) : _c('span', [_vm._v("点赞")])]), _vm._v(" "), (item.donate_url) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.onShowSupport(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-a-Iconawesome-donate"
    }), _vm._v(" "), _c('span', [_vm._v("参与")])]) : _vm._e(), _vm._v(" "), (_vm.canShare && item.share_status > 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.onShowShare(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-share"
    }), _vm._v("分享\n                ")]) : _vm._e()])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.priest), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'bookshelf',
          params: {
            catid: item.id
          },
          query: {
            name: item.category
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumb
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.category))])])
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.notes), function(item, i) {
    return _c('a', {
      key: i,
      staticClass: "item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onEdit(i)
        },
        "&touchstart": function($event) {
          return _vm.onTouchStart(i)
        },
        "&touchmove": function($event) {
          return _vm.onTouchEnd.apply(null, arguments)
        },
        "&touchend": function($event) {
          return _vm.onTouchEnd.apply(null, arguments)
        }
      }
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("datetime")(item.addtime)))])])])
  }), 0), _vm._v(" "), (_vm.none) ? _c('div', {
    staticClass: "none"
  }, [_vm._v("暂时没有笔记")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提示：长按可进行删除操作")]), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('router-link', {
    staticClass: "fixedTop",
    attrs: {
      "to": {
        name: 'search'
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "icon icon-search"
  }), _vm._v(" 请输入关键字")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.roots), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'bookshelf',
          params: {
            catid: item.id
          },
          query: {
            name: item.category
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: _vm._f("icon")(item.category)
    }), _vm._v("\n      " + _vm._s(item.category) + "\n    ")])
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'category-all'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-more"
  }), _vm._v("\n      全部\n    ")])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, _vm._l((_vm.info.logo), function(item, i) {
    return _c('img', {
      key: i,
      attrs: {
        "src": item
      }
    })
  }), 0), _vm._v(" "), (_vm.info.progress < 100) ? _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text1))]) : _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text3))]), _vm._v(" "), (_vm.info.progress < 100) ? [_c('video', {
    attrs: {
      "src": _vm.info.video,
      "poster": _vm.info.poster,
      "controls": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress1"
  }, [_c('span', [_vm._v("当前进度"), _c('label', [_vm._v(_vm._s(_vm.info.progress) + "%")])]), _vm._v(" "), _c('label', [_vm._v("更新于" + _vm._s(_vm.info.update_time))])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "fill",
    style: ({
      width: _vm.info.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.info.text2))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "submit"
  }, [_vm._v(_vm._s(_vm.info.button_text))])])] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.headimgurl
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'news'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oNews"
  }), _vm._v(" "), _c('span', [_vm._v("站内公告")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'suggest'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oMail"
  }), _vm._v(" "), _c('span', [_vm._v("留言反馈")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('playback')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oPlay"
  }), _vm._v(" "), _c('span', [_vm._v("播放记录")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('favourite')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oStar"
  }), _vm._v(" "), _c('span', [_vm._v("我的收藏")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('note')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oNote"
  }), _vm._v(" "), _c('span', [_vm._v("我的笔记")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onShare
    }
  }, [_c('i', {
    staticClass: "icon icon-oShare"
  }), _vm._v(" "), _c('span', [_vm._v("邀请好友")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oAbout"
  }), _vm._v(" "), _c('span', [_vm._v("关于我们")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "我们的成长离不开您的支持和建议"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    attrs: {
      "placeholder": "您的邮箱/QQ/手机号"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSend
    }
  }, [_vm._v("发 送")])])
},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('html-content', {
    attrs: {
      "value": _vm.value.content
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend-cell"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bookshelf',
        params: {
          catid: _vm.value.catid
        },
        query: {
          name: _vm.value.catname
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon",
    class: _vm._f("icon")(_vm.value.catname)
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.value.catname))]), _vm._v(" "), _c('span', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.value.items), function(item, index) {
    return _c('movie-cover', {
      key: index,
      staticClass: "home-movie",
      attrs: {
        "value": item
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.viewClass
  }, [_c('keep-alive', [(_vm.$route.meta && _vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta || !_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view"
  }) : _vm._e(), _vm._v(" "), (_vm.headVisible) ? _c('app-head', {
    attrs: {
      "backVisible": _vm.backVisible
    }
  }) : _vm._e(), _vm._v(" "), (_vm.footVisible) ? _c('app-foot') : _vm._e(), _vm._v(" "), (!_vm.isToolDisabled) ? _c('app-tool') : _vm._e(), _vm._v(" "), (!_vm.isDownVisible) ? _c('a', {
    staticClass: "download scaleE",
    attrs: {
      "href": "http://www.fytvapp.com/mobile/"
    }
  }, [_vm._v("\n        点此安装福音TV App"), _c('br'), _vm._v("访问FYTV.NET下载安装观看更多主内视频\n    ")]) : _vm._e(), _vm._v(" "), _c('app-share'), _vm._v(" "), (_vm.welcomeVisible) ? _c('welcome', {
    attrs: {
      "disable": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar"
  }, [_c('div', [_c('a', {
    staticClass: "icon icon-detail",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('intro')
      }
    }
  }, [_vm._v("介绍")]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-playlist",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('list')
      }
    }
  }, [_vm._v("列表")]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-star",
    class: {
      on: _vm.favourite
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onFav
    }
  }, [_vm._v("收藏")]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-note",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onNote
    }
  }, [_vm._v("笔记")])]), _vm._v(" "), _c('a', {
    staticClass: "icon icon-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('download')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("相关视频:")]), _vm._v(" "), _c('span', {
    staticClass: "video"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("标题:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.subtitle),
      expression: "item.subtitle"
    }],
    attrs: {
      "placeholder": "请输入标题"
    },
    domProps: {
      "value": (_vm.item.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "subtitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.content),
      expression: "item.content"
    }],
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.item.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保 存")])])])
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.isWechat) ? _c('div', {
    staticClass: "t1"
  }, [_vm._v("绑定手机")]) : _c('div', {
    staticClass: "t1"
  }, [_vm._v("登录/注册")]), _vm._v(" "), _c('div', {
    staticClass: "t2"
  }, [_vm._v("绑定手机享受更多服务")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "t0"
  }, [_vm._v("\n        当前集数已播放完毕，邀请您登录/注册福音TV会员\n        "), _c('br'), _vm._v("避免失联，随时在线\n    ")]) : _c('div', {
    staticClass: "t0"
  }, [_vm._v("\n        邀请您登录/注册福音影视网（福音TV）会员\n        "), _c('br'), _vm._v("避免失联，随时在线\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.areaVisible = true
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.area))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "placeholder": "请输入您的手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('a', {
    staticClass: "icon icon-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.phone = ''
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "placeholder": "请输入获取的验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.cold > 0) ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.cold) + "s")]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSendCode
    }
  }, [_vm._v("发送验证码")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.isWechat) ? _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确认绑定")]) : _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("登录/注册")])]), _vm._v(" "), (_vm.ignore) ? _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    staticClass: "off",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("下次再说")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.areaVisible) ? _c('div', {
    ref: "areas",
    staticClass: "areas"
  }, [_vm._l((_vm.areas), function(j, i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "areas-title"
    }, [_vm._v(_vm._s(i))]), _vm._v(" "), _vm._l((_vm.areas[i]), function(item, k) {
      return _c('a', {
        key: k,
        staticClass: "areas-item",
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.onChooseArea(item)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(item.n))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.c))])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, _vm._l((_vm.areas), function(j, i) {
    return _c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onScrollTo(i)
        }
      }
    }, [_vm._v(_vm._s(i))])
  }), 0)], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t5"
  }, [_vm._v("\n        手机号将作为您的会员账户，可以在福音TV app\n        "), _c('br'), _vm._v("上直接登录，笔记、收藏云端在线，多端同步。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fytvapp.com"
    }
  }, [_vm._v("\n            点击下载福音TV App\n            "), _c('br'), _vm._v("(暂不绑定)\n        ")])])
}]}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('html-content', {
    attrs: {
      "value": _vm.value.content
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playlist"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        video: _vm.player.index === index && _vm.player.video, audio: _vm.player.index === index && _vm.player.audio
      }
    }, [_c('a', {
      staticClass: "name",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayVideo(index, true)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('a', {
      staticClass: "icon icon-play-o",
      class: {
        off: !item.mp4
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayVideo(index, false)
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "icon icon-music1",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayAudio(index)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "movie-cover",
    class: _vm.more,
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClick,
      "&touchstart": function($event) {
        return _vm.onTouchStart.apply(null, arguments)
      },
      "&touchend": function($event) {
        return _vm.onTouchEnd.apply(null, arguments)
      },
      "&touchmove": function($event) {
        return _vm.onTouchEnd.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "bg",
    style: ({
      backgroundImage: 'url(' + _vm.value.pic + ')'
    })
  }), _vm._v(" "), _vm._t("default", function() {
    return [_c('div', [_vm._v(_vm._s(_vm.value.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.value.actor))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.value.director))]), _vm._v(" "), (_vm.more === 'add') ? _c('div', [_vm._v("发布日期\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("date")(_vm.value.addtime)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.more === 'update') ? _c('div', [_vm._v("更新日期\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("date")(_vm.value.modifytime)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.more === 'simple') ? _c('div', [_vm._v(_vm._s(_vm._f("date")(_vm.value.addtime)))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-swipe', {
    staticClass: "banner"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('mt-swipe-item', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.picture
      }
    })])])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore
    }
  }, [_c('banner'), _vm._v(" "), _c('quick'), _vm._v(" "), _c('div', {
    staticClass: "recs"
  }, _vm._l((_vm.recommendations), function(item, index) {
    return _c('recommendation', {
      key: index,
      attrs: {
        "value": item
      }
    })
  }), 1), _vm._v(" "), (_vm.unreadVisible) ? _c('router-link', {
    staticClass: "unread",
    attrs: {
      "to": {
        name: 'news'
      },
      "href": "javascript:;"
    }
  }, [_vm._v("您有未读消息")]) : _vm._e(), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.value.content))]), _vm._v(" "), _c('div', {
    staticClass: "version"
  }, [_vm._v("v1.0.1")])])
},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tab fixedTop"
  }, [_c('a', {
    class: {
      on: _vm.type === 0
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.type = 0
      }
    }
  }, [_vm._v("最近更新")]), _vm._v(" "), _c('a', {
    class: {
      on: _vm.type === 1
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.type = 1
      }
    }
  }, [_vm._v("最新发布")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "more": _vm.more
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "quick"
  }, [_vm._l((_vm.menu), function(item, i) {
    return [_c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])])]
  })], 2), _vm._v(" "), (_vm.ad.open && _vm.ad.target !== 'miniprogram') ? _c('a', {
    staticClass: "ad",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClickAd
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.ad.image
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.visible) ? _c('div', {
    staticClass: "mask",
    staticStyle: {
      "z-index": "900"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "confirm-scale"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "app-confirm",
    staticStyle: {
      "z-index": "901"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancel))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onOK
    }
  }, [_vm._v(_vm._s(_vm.ok))])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('a', {
    staticClass: "app-share",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('img', {
    attrs: {
      "src": "static/wx_tip.png"
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-tool",
    class: {
      on: _vm.on
    }
  }, [_c('a', {
    staticClass: "icon icon-more",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSwitch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tool-panel"
  }, [_c('a', {
    staticClass: "icon icon-home",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onHome
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-search",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSearch
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-share",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onShare
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appHead",
    class: {
      dark: _vm.isLives
    }
  }, [_c('div', {
    staticClass: "head1"
  }, [(_vm.backVisible) ? _c('span', [_c('a', {
    staticClass: "icon icon-back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goBack
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLives) ? _c('div', {
    staticClass: "ifuyin"
  }, [_c('img', {
    attrs: {
      "src": "static/logo-icon.png"
    }
  }), _vm._v("一起看-福音影视网 iFUYIN.COM\n    ")]) : _c('div', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.isLives) ? _c('div', {
    staticClass: "head2"
  }, [_c('a', {
    attrs: {
      "href": "/short/index.html?#/short"
    }
  }, [_vm._v("微视频")]), _vm._v(" "), _c('i'), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "live"
  }, [_vm._v("一起看"), _c('label', [_vm._v("直播")])])
}]}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "event": "selected",
        "more": "simple"
      },
      on: {
        "selected": _vm.onSelected,
        "longTap": _vm.onLongTap
      }
    })
  }), 1), _vm._v(" "), (_vm.list.length === 0) ? _c('div', {
    staticClass: "none"
  }, [_vm._v("暂时没有播放记录")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提示：长按可进行删除操作")]), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore,
      "close": _vm.onClose
    }
  }, [(_vm.value.length > 0) ? _c('list', {
    ref: "list",
    attrs: {
      "loadNextPage": _vm.loadNext,
      "clear": _vm.clear
    }
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.searchOnce && _vm.bookshelf.length === 0) ? _c('div', {
    staticClass: "notFound"
  }, [_vm._v("没有找到相关内容")]) : _vm._l((_vm.bookshelf), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "event": "selected"
      },
      on: {
        "selected": _vm.onSelected
      }
    })
  })], 2)]) : _c('div', {
    staticClass: "history"
  }, _vm._l((_vm.history), function(item, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input fixedTop"
  }, [_c('div', [_c('i', {
    staticClass: "icon icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-clear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onClearText
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[138]);


// WEBPACK FOOTER //
// static/js/app.85bec63ddaa7e906a4b2.js